// =====================================================================
// PLENARIUM - Painel do vereador em CARDS (PLENARIUM:CARDS)
// Pecas usadas pelo PainelVereador.jsx (a logica do painel continua a
// mesma; estas pecas so organizam as telas):
//  - InicioCards:    tela de cards (Votacao, Presencas, Sessoes...)
//  - BarraSecao:     faixa do topo de cada tela: "← Inicio", foto do
//                    vereador, "Ordem do Dia", "Controles" (Presidente)
//  - TelaPresenca:   com sessao aberta e sem presenca, a tela fica no
//                    "Registrar presenca" ate ele confirmar
//  - GavetaOrdem:    Ordem do Dia com as materias e TODOS os documentos,
//                    aberta por cima da Votacao
//  - PresencaAoVivo: presencas por sessao (a em andamento em tempo real)
//  - VotosNominais:  em Sessoes Anteriores, como cada vereador votou
//  - AvisoResultado: resultado quando uma votacao e encerrada
//  - CSS_CARDS:      esconde o menu lateral e a barra de baixo
// =====================================================================
import React, { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { io } from 'socket.io-client';
import {
  Vote, History, FileText, ClipboardList, Plus, Users, KeyRound,
  Camera, Sun, Moon, RefreshCw, LogOut, CheckCircle, Play, Calendar, X, ChevronDown, ChevronUp, Home, Bell, Monitor, Search, Clock, MapPin, Radio, ChevronRight,
  ScrollText, // PLENARIUM:LEITURAS
  BookOpen, // PLENARIUM:ATA_RETIFICACAO
  Mic // PLENARIUM:TRIBUNA
} from 'lucide-react';
import { abrirDocumento } from './TodosProjetos';
import { useTribuna, resumoTribuna } from './Tribuna'; // PLENARIUM:TRIBUNA
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export const CSS_CARDS = `
  .pv-root.pv-cards .pv-sidebar { display: none !important; }
  .pv-root.pv-cards .pv-bottom-bar { display: none !important; }
  .pv-root.pv-cards .pv-main { padding-bottom: 0 !important; }
  body.pvc-topo-on:not(.pvc-topo-pres) .pv-root.pv-cards .pv-cabecalho-camara { display: none !important; }
  body.pvc-topo-on.pvc-topo-pres .pv-root.pv-cards .pv-header-desktop,
  body.pvc-topo-on.pvc-topo-pres .pv-root.pv-cards .pv-header-mobile { display: none !important; }
  .pvc-inicio-tela { flex: 1; overflow-y: auto; background: #f1f5f9; }
  .pvc-topo { position: relative; z-index: 5; display: flex; flex-direction: column; align-items: stretch; gap: 14px; padding: 22px 28px 30px; color: #fff;
    background: radial-gradient(120% 140% at 85% -20%, rgba(96,165,250,.55) 0%, rgba(96,165,250,0) 55%), radial-gradient(90% 120% at 10% 130%, rgba(30,64,175,.9) 0%, rgba(30,64,175,0) 60%), linear-gradient(120deg, #0b2a6b 0%, #1446a8 55%, #1d63d8 100%);
    box-shadow: 0 6px 20px rgba(20,70,168,.18); }
  .pvc-topo::after { content: ''; position: absolute; inset: 0; pointer-events: none; background: radial-gradient(60% 50% at 70% 120%, rgba(255,255,255,.14) 0%, rgba(255,255,255,0) 70%); }
  .pvc-topo-camara { display: flex; align-items: center; gap: 16px; min-width: 0; }
  .pvc-topo-brasao { width: 78px; height: 86px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
  .pvc-topo-brasao img { max-width: 100%; max-height: 100%; object-fit: contain; filter: drop-shadow(0 2px 6px rgba(0,0,0,.25)); }
  .pvc-topo-div { width: 1px; align-self: stretch; min-height: 54px; background: rgba(255,255,255,.35); flex-shrink: 0; }
  .pvc-topo-pre { display: block; font-size: .92rem; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase; opacity: .92; }
  .pvc-topo-cidade { display: block; font-size: 2rem; font-weight: 900; letter-spacing: .5px; text-transform: uppercase; line-height: 1.05; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .pvc-topo-perfil { position: relative; display: flex; align-items: center; gap: 14px; flex-shrink: 0; }
  .pvc-topo-foto { background: none; border: none; display: flex; align-items: center; gap: 8px; cursor: pointer; padding: 0; font-family: inherit; }
  .pvc-topo-circ { width: 66px; height: 66px; border-radius: 50%; overflow: hidden; border: 3px solid #fff; background: #e2e8f0; display: flex; align-items: center; justify-content: center; color: #475569; font-weight: 800; font-size: 1.3rem; box-shadow: 0 4px 12px rgba(0,0,0,.25); }
  .pvc-topo-circ img { width: 100%; height: 100%; object-fit: cover; object-position: top; }
  .pvc-menu { position: absolute; right: 0; top: calc(100% + 10px); width: 250px; background: #fff; border-radius: 16px; box-shadow: 0 16px 40px rgba(15,23,42,.22); padding: 8px; color: #0f172a; z-index: 20; }
  .pvc-menu-nome { padding: 10px 12px 12px; border-bottom: 1px solid #e2e8f0; margin-bottom: 6px; }
  .pvc-menu-nome b { display: block; font-size: 1rem; }
  .pvc-menu-nome small { color: #64748b; }
  .pvc-menu-item { width: 100%; display: flex; align-items: center; gap: 10px; background: none; border: none; border-radius: 10px; padding: 12px; font-size: 1rem; font-weight: 700; color: #334155; cursor: pointer; font-family: inherit; text-align: left; }
  .pvc-menu-item:hover, .pvc-menu-item:active { background: #f1f5f9; }
  .pvc-menu-marca { text-align: center; color: #94a3b8; font-size: .72rem; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; padding: 8px 0 4px; border-top: 1px solid #e2e8f0; margin-top: 6px; }
  .pvc-topo-linha { display: flex; align-items: center; justify-content: space-between; gap: 14px; position: relative; z-index: 2; }
  .pvc-topo.pvc-topo-hero { padding-bottom: 64px; position: sticky; top: 0; z-index: 30; }
  .pvc-tema { border-top: 1px solid #e2e8f0; margin-top: 6px; padding: 10px 12px 8px; }
  .pvc-tema-tit { display: block; font-size: .78rem; font-weight: 800; color: #64748b; text-transform: uppercase; letter-spacing: .6px; margin-bottom: 8px; }
  .pvc-tema-ops { display: grid; grid-template-columns: repeat(3, 1fr); gap: 4px; background: #f1f5f9; border-radius: 12px; padding: 4px; }
  .pvc-tema-op { display: flex; flex-direction: column; align-items: center; gap: 3px; background: none; border: none; border-radius: 9px; padding: 7px 4px; font-family: inherit; font-size: .78rem; font-weight: 700; color: #475569; cursor: pointer; }
  .pvc-tema-op.ativa { background: #fff; color: #1d4ed8; box-shadow: 0 1px 4px rgba(15,23,42,.12); }
  .pvc-topo-extra { position: relative; z-index: 1; display: flex; flex-direction: column; align-items: flex-start; }
  .pvc-onda { position: absolute; left: 0; right: 0; bottom: -1px; width: 100%; height: 46px; z-index: 0; pointer-events: none; }
  .pvc-sino { position: relative; background: none; border: none; cursor: pointer; padding: 6px; display: flex; align-items: center; justify-content: center; border-radius: 12px; }
  .pvc-sino:hover { background: rgba(255,255,255,.12); }
  .pvc-sino-num { position: absolute; top: 0; right: 0; min-width: 19px; height: 19px; border-radius: 999px; background: #ef4444; color: #fff; font-size: .72rem; font-weight: 900; display: flex; align-items: center; justify-content: center; padding: 0 5px; border: 2px solid #1446a8; }
  .pvc-avisos { width: 290px; right: 70px; }
  .pvc-aviso-ponto { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; margin-top: 6px; }
  .pvc-inicio-corpo { padding: 14px 28px 20px; }
  .pvc-ola { font-size: 1.05rem; color: rgba(255,255,255,.88); }
  .pvc-ola-nome { font-size: 1.45rem; font-weight: 500; color: #fff; line-height: 1.15; margin-top: 1px; }
  .pvc-ola-sub { color: rgba(255,255,255,.8); font-size: 1.05rem; margin: 8px 0 0; }
  .pvc-ola-sessao { display: inline-flex; align-items: center; gap: 8px; background: #fff; color: #b91c1c; font-weight: 800; border: none; border-radius: 999px; padding: 8px 14px; margin: 12px 0 0; font-size: .95rem; cursor: pointer; font-family: inherit; box-shadow: 0 4px 14px rgba(0,0,0,.18); max-width: 100%; }
  .pvc-ola-sessao-txt { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; }
  .pvc-assinatura { text-align: center; color: #94a3b8; font-size: .78rem; letter-spacing: .3px; padding: 26px 0 6px; opacity: .85; }
  .pvc-ponto { width: 8px; height: 8px; border-radius: 50%; background: #dc2626; animation: pulse 1.4s ease infinite; }
  .pvc-topo.pvc-topo-comp { padding: 14px 26px 18px; }
  .pvc-topo-comp .pvc-topo-brasao { width: 60px; height: 66px; }
  .pvc-topo-comp .pvc-topo-div { min-height: 44px; }
  .pvc-topo-comp .pvc-topo-cidade { font-size: 1.7rem; }
  .pvc-topo-quem { display: flex; flex-direction: column; align-items: flex-start; color: #fff; text-align: left; line-height: 1.25; }
  .pvc-topo-quem b { font-size: 1rem; font-weight: 800; text-transform: uppercase; letter-spacing: .3px; white-space: nowrap; }
  .pvc-topo-quem small { font-size: .82rem; opacity: .8; }
  .pvc-abas { display: flex; gap: 4px; padding: 0 20px; background: #fff; border-bottom: 1px solid #e2e8f0; overflow-x: auto; scrollbar-width: none; flex-shrink: 0; position: sticky; top: 0; z-index: 4; box-shadow: 0 2px 8px rgba(15,23,42,.04); }
  .pvc-abas::-webkit-scrollbar { display: none; }
  .pvc-aba { background: none; border: none; border-bottom: 3px solid transparent; display: flex; align-items: center; gap: 9px; padding: 12px 14px 11px; cursor: pointer; font-family: inherit; font-weight: 700; font-size: .95rem; color: #334155; white-space: nowrap; flex-shrink: 0; }
  .pvc-aba:hover { background: #f8fafc; }
  .pvc-aba.ativa { border-bottom-color: #2563eb; color: #1d4ed8; }
  .pvc-aba-ic { position: relative; width: 34px; height: 34px; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .pvc-aba-ponto { position: absolute; top: -3px; right: -3px; width: 10px; height: 10px; border-radius: 50%; background: #dc2626; border: 2px solid #fff; animation: pulse 1.4s ease infinite; }
  .pvc-barra-so-atualizar { padding-top: 12px; }
  .pvc-rot-curto { display: none; }
  .pvc-abas { display: none !important; }
  .pvc-rodape { position: fixed; left: 0; right: 0; bottom: 0; z-index: 1000; display: flex; background: rgba(255,255,255,.97); border-top: 1px solid #e2e8f0; box-shadow: 0 -4px 16px rgba(15,23,42,.08); padding: 6px 4px calc(6px + env(safe-area-inset-bottom)); backdrop-filter: blur(8px); }
  .pvc-rod { flex: 1; background: none; border: none; display: flex; flex-direction: column; align-items: center; gap: 3px; padding: 4px 2px; cursor: pointer; font-family: inherit; font-size: .74rem; font-weight: 700; color: #64748b; min-width: 0; }
  .pvc-rod span:last-child { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%; }
  .pvc-rod.ativa { color: #1d4ed8; }
  .pvc-rod-ic { position: relative; width: 52px; height: 30px; border-radius: 999px; display: flex; align-items: center; justify-content: center; transition: background .15s; }
  .pvc-rod.ativa .pvc-rod-ic { background: #e0edff; }
  .pvc-rod-ic svg { width: 22px; height: 22px; }
  .pvc-tres-pontos { font-size: 1.05rem; letter-spacing: 1px; font-weight: 900; line-height: 1; }
  body.pvc-com-rodape .pv-root.pv-cards .pv-main { padding-bottom: calc(72px + env(safe-area-inset-bottom)) !important; }
  .pvc-mais-fundo { position: fixed; inset: 0; z-index: 999; background: rgba(15,23,42,.35); display: flex; align-items: flex-end; }
  .pvc-mais { width: 100%; background: #fff; border-radius: 22px 22px 0 0; padding: 8px 12px calc(84px + env(safe-area-inset-bottom)); box-shadow: 0 -10px 30px rgba(15,23,42,.18); }
  .pvc-mais-alca { width: 44px; height: 5px; border-radius: 99px; background: #cbd5e1; margin: 4px auto 10px; }
  .pvc-mais-item { width: 100%; display: flex; align-items: center; gap: 12px; background: none; border: none; border-radius: 14px; padding: 12px; font-family: inherit; font-size: 1.05rem; font-weight: 700; color: #0f172a; cursor: pointer; text-align: left; }
  .pvc-mais-item.ativa { background: #eff6ff; color: #1d4ed8; }
  .pvc-barra-so-atualizar, .pvc-barra .pvc-bt[title="Atualizar"] { display: none !important; }
  @media (min-width: 1025px) and (hover: hover) and (pointer: fine) {
    .pvc-topo { background: radial-gradient(90% 160% at 100% -40%, rgba(56,97,180,.35) 0%, rgba(56,97,180,0) 60%), linear-gradient(115deg, #071226 0%, #0c1c3d 50%, #11285a 100%); box-shadow: 0 4px 18px rgba(7,18,38,.28); }
    .pvc-topo::after { background: none; }
    .pvc-sino-num { border-color: #0c1c3d; }
    .pvc-topo.pvc-topo-hero { padding: 12px 28px 14px; gap: 8px; }
    .pvc-topo-hero .pvc-onda { display: none; }
    .pvc-topo-hero .pvc-topo-brasao { width: 52px; height: 58px; }
    .pvc-topo-hero .pvc-topo-div { min-height: 40px; }
    .pvc-topo-hero .pvc-topo-pre { font-size: .78rem; }
    .pvc-topo-hero .pvc-topo-cidade { font-size: 1.5rem; }
    .pvc-topo-hero .pvc-topo-circ { width: 50px; height: 50px; }
    .pvc-topo-hero .pvc-topo-extra { flex-direction: row; align-items: baseline; flex-wrap: wrap; column-gap: 8px; row-gap: 6px; }
    .pvc-topo-hero .pvc-ola, .pvc-topo-hero .pvc-ola-nome, .pvc-topo-hero .pvc-ola-sub { display: none; }
    .pvc-topo-hero .pvc-topo-extra:not(:has(.pvc-ola-sessao)) { display: none; }
    .pvc-topo-hero .pvc-ola-sessao { margin: 0; }
    .pvc-abas { display: flex !important; }
    .pvc-barra-so-atualizar { display: flex !important; }
    .pvc-barra .pvc-bt[title="Atualizar"] { display: flex !important; }
    .pvc-rodape, .pvc-mais-fundo { display: none !important; }
    body.pvc-com-rodape .pv-root.pv-cards .pv-main { padding-bottom: 0 !important; }
  }
  /* Botoes de voto (claros, com o simbolo num circulo de cor) */
  .pv-root.pv-cards .pv-botoes-voto { gap: 14px; }
  .pv-root.pv-cards .pv-btn-voto { flex-direction: column; gap: 12px; border: 2px solid; border-radius: 20px; padding: 22px 8px; font-size: 1.3rem; font-weight: 900; letter-spacing: .6px; transition: transform .12s ease, box-shadow .12s ease, filter .12s; }
  .pv-root.pv-cards .pv-btn-voto svg { display: none; }
  .pv-root.pv-cards .pv-btn-voto::before { content: ''; width: 64px; height: 64px; border-radius: 50%; flex-shrink: 0; background-position: center; background-repeat: no-repeat; background-size: 34px; }
  .pv-root.pv-cards .pv-btn-voto:hover { transform: translateY(-2px); filter: none; }
  .pv-root.pv-cards .pv-btn-voto:active { transform: scale(.97); }
  .pv-root.pv-cards .pv-btn-sim { background: #f0fdf4; border-color: #4ade80; color: #166534; box-shadow: 0 6px 18px rgba(22,163,74,.16); }
  .pv-root.pv-cards .pv-btn-sim::before { background-color: #16a34a; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 12.5l4.5 4.5L19 7.5'/%3E%3C/svg%3E"); box-shadow: 0 6px 14px rgba(22,163,74,.35); }
  .pv-root.pv-cards .pv-btn-nao { background: #fef2f2; border-color: #f87171; color: #b91c1c; box-shadow: 0 6px 18px rgba(220,38,38,.16); }
  .pv-root.pv-cards .pv-btn-nao::before { background-color: #dc2626; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6.5 6.5l11 11M17.5 6.5l-11 11'/%3E%3C/svg%3E"); box-shadow: 0 6px 14px rgba(220,38,38,.35); }
  .pv-root.pv-cards .pv-btn-abst { background: #fffbeb; border-color: #fbbf24; color: #92400e; box-shadow: 0 6px 18px rgba(217,119,6,.16); }
  .pv-root.pv-cards .pv-btn-abst::before { background-color: #d97706; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 12h12'/%3E%3C/svg%3E"); box-shadow: 0 6px 14px rgba(217,119,6,.35); }
  /* Votacao: botoes cheios (verde, vermelho, amarelo) e fundo azul claro com onda (PLENARIUM:VOTO_CHEIO) */
  .pv-root.pv-cards .pv-votacao { background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320' preserveAspectRatio='none'%3E%3Cpath d='M0 170 C240 110 480 230 720 180 C960 130 1200 120 1440 170 L1440 320 L0 320 Z' fill='%233b82f6' fill-opacity='.07'/%3E%3Cpath d='M0 230 C260 180 520 280 780 235 C1040 190 1240 200 1440 230 L1440 320 L0 320 Z' fill='%233b82f6' fill-opacity='.06'/%3E%3C/svg%3E") left bottom / 100% 260px no-repeat, linear-gradient(180deg, #f4f8ff 0%, #e8f0fe 100%); }
  .pv-root.pv-cards .pv-btn-voto { border: none; color: #fff; text-shadow: 0 1px 2px rgba(0,0,0,.18); }
  .pv-root.pv-cards .pv-btn-voto:hover { filter: brightness(1.05); }
  .pv-root.pv-cards .pv-btn-sim { background: linear-gradient(180deg, #2fd16d 0%, #16a34a 100%); color: #fff; box-shadow: 0 10px 22px rgba(22,163,74,.32), inset 0 1px 0 rgba(255,255,255,.25); }
  .pv-root.pv-cards .pv-btn-sim::before { background-color: #12793a; box-shadow: inset 0 2px 6px rgba(0,0,0,.18); }
  .pv-root.pv-cards .pv-btn-nao { background: linear-gradient(180deg, #f8615f 0%, #dc2626 100%); color: #fff; box-shadow: 0 10px 22px rgba(220,38,38,.32), inset 0 1px 0 rgba(255,255,255,.25); }
  .pv-root.pv-cards .pv-btn-nao::before { background-color: #b31b1b; box-shadow: inset 0 2px 6px rgba(0,0,0,.18); }
  .pv-root.pv-cards .pv-btn-abst { background: linear-gradient(180deg, #fcc73a 0%, #f59e0b 100%); color: #fff; box-shadow: 0 10px 22px rgba(245,158,11,.32), inset 0 1px 0 rgba(255,255,255,.3); }
  .pv-root.pv-cards .pv-btn-abst::before { background-color: #c76b06; box-shadow: inset 0 2px 6px rgba(0,0,0,.18); }
  .pv-root.pv-cards .pv-btn-voto:disabled { opacity: .6; }
  .pv-root.pv-cards .pv-como-votar-label { color: #334155 !important; font-weight: 700 !important; font-size: 1.12rem !important; }
  /* Confirmacao do voto */
  @keyframes pvcSobe { from { opacity: 0; transform: translateY(18px) scale(.97); } to { opacity: 1; transform: none; } }
  @keyframes pvcFundo { from { opacity: 0; } to { opacity: 1; } }
  .pvc-cv-fundo { position: fixed; inset: 0; z-index: 2147483000; background: rgba(15,23,42,.55); backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; padding: 16px; animation: pvcFundo .15s ease; }
  .pvc-cv { width: min(420px, 100%); background: #fff; border-radius: 26px; padding: 28px 24px 22px; text-align: center; box-shadow: 0 30px 60px rgba(15,23,42,.35); animation: pvcSobe .2s ease; }
  .pvc-cv-ic { width: 88px; height: 88px; border-radius: 50%; margin: 0 auto 14px; display: flex; align-items: center; justify-content: center; }
  .pvc-cv-ic::before { content: ''; width: 64px; height: 64px; border-radius: 50%; background-position: center; background-repeat: no-repeat; background-size: 34px; }
  .pvc-cv-SIM .pvc-cv-ic { background: #dcfce7; } .pvc-cv-SIM .pvc-cv-ic::before { background-color: #16a34a; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 12.5l4.5 4.5L19 7.5'/%3E%3C/svg%3E"); }
  .pvc-cv-NAO .pvc-cv-ic { background: #fee2e2; } .pvc-cv-NAO .pvc-cv-ic::before { background-color: #dc2626; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6.5 6.5l11 11M17.5 6.5l-11 11'/%3E%3C/svg%3E"); }
  .pvc-cv-ABSTENCAO .pvc-cv-ic { background: #fef3c7; } .pvc-cv-ABSTENCAO .pvc-cv-ic::before { background-color: #d97706; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 12h12'/%3E%3C/svg%3E"); }
  .pvc-cv-tit { font-size: 1.3rem; font-weight: 900; color: #0f172a; }
  .pvc-cv-voto { display: inline-block; margin: 12px 0 4px; padding: 8px 22px; border-radius: 999px; font-weight: 900; font-size: 1.35rem; letter-spacing: .6px; }
  .pvc-cv-SIM .pvc-cv-voto { background: #dcfce7; color: #166534; } .pvc-cv-NAO .pvc-cv-voto { background: #fee2e2; color: #b91c1c; } .pvc-cv-ABSTENCAO .pvc-cv-voto { background: #fef3c7; color: #92400e; }
  .pvc-cv-materia { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 14px; padding: 10px 12px; margin: 14px 0 6px; text-align: left; }
  .pvc-cv-materia small { display: block; color: #64748b; font-weight: 700; font-size: .78rem; }
  .pvc-cv-materia b { display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; color: #0f172a; font-size: .98rem; line-height: 1.35; }
  .pvc-cv-aviso { color: #64748b; font-size: .92rem; margin: 10px 0 18px; display: flex; gap: 6px; align-items: center; justify-content: center; }
  .pvc-cv-bts { display: flex; gap: 10px; }
  .pvc-cv-bts button { flex: 1; border-radius: 14px; padding: 15px 10px; font-size: 1.05rem; font-weight: 800; cursor: pointer; font-family: inherit; border: 2px solid transparent; }
  .pvc-cv-cancelar { background: #fff; border-color: #e2e8f0 !important; color: #334155; }
  .pvc-cv-ok { color: #fff; }
  .pvc-cv-SIM .pvc-cv-ok { background: #16a34a; box-shadow: 0 8px 18px rgba(22,163,74,.35); }
  .pvc-cv-NAO .pvc-cv-ok { background: #dc2626; box-shadow: 0 8px 18px rgba(220,38,38,.35); }
  .pvc-cv-ABSTENCAO .pvc-cv-ok { background: #d97706; box-shadow: 0 8px 18px rgba(217,119,6,.35); }
  .pvc-cv-ok:disabled { opacity: .7; cursor: wait; }
  .pvc-barra { display: flex; align-items: center; gap: 12px; padding: 14px 28px 4px; flex-shrink: 0; flex-wrap: wrap; }
  .pvc-barra-titulo { font-size: 1.6rem; font-weight: 900; color: #0f172a; flex: 1; min-width: 120px; }
  .pvc-bt { border: 1px solid #cbd5e1; background: #fff; color: #334155; border-radius: 12px; padding: 11px 16px; font-weight: 800; font-size: 1rem; cursor: pointer; display: flex; align-items: center; gap: 7px; font-family: inherit; white-space: nowrap; box-shadow: 0 1px 2px rgba(15,23,42,.04); }
  .pvc-bt-inicio { background: #e0edff; border-color: #e0edff; color: #1d4ed8; padding: 11px 18px; }
  .pvc-bt-azul { background: #eff6ff; border-color: #bfdbfe; color: #1d4ed8; }
  .pvc-bt-verm { background: #dc2626; border-color: #dc2626; color: #fff; }
  .pvc-ss { flex: 1; overflow-y: auto; padding: 14px 28px 28px; display: flex; flex-direction: column; gap: 16px; }
  .pvc-ss-perfil { background: #fff; border-radius: 20px; padding: 22px 24px; display: flex; align-items: center; gap: 26px; box-shadow: 0 4px 16px rgba(15,23,42,.06); }
  .pvc-ss-foto { width: 140px; height: 140px; border-radius: 14px; overflow: hidden; flex-shrink: 0; background: #e2e8f0; display: flex; align-items: center; justify-content: center; font-size: 2.2rem; font-weight: 800; color: #64748b; }
  .pvc-ss-foto img { width: 100%; height: 100%; object-fit: cover; object-position: center top; }
  .pvc-ss-rot { font-size: .8rem; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: .6px; }
  .pvc-ss-nome { font-size: 1.9rem; font-weight: 900; color: #0f172a; text-transform: uppercase; line-height: 1.15; margin-top: 4px; }
  .pvc-pill { background: #f1f5f9; color: #64748b; font-weight: 700; font-size: .9rem; padding: 5px 14px; border-radius: 999px; }
  .pvc-pill-azul { background: #e0edff; color: #1d4ed8; }
  .pvc-ss-desc { color: #475569; font-size: 1.05rem; }
  .pvc-ss-stats { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }
  .pvc-ss-stat { background: #fff; border-radius: 20px; padding: 18px 22px; display: flex; align-items: center; gap: 22px; box-shadow: 0 4px 16px rgba(15,23,42,.06); }
  .pvc-ss-stat-ic { width: 76px; height: 68px; border-radius: 14px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .pvc-ss-val { font-size: 2.3rem; font-weight: 900; color: #1d4ed8; line-height: 1.1; }
  .pvc-ss-sub { color: #64748b; font-size: 1rem; }
  .pvc-ss-sit { border-radius: 20px; padding: 18px 22px 24px; border: 1px solid #dbeafe; position: relative; overflow: hidden;
    background: radial-gradient(80% 120% at 100% 100%, rgba(147,197,253,.45) 0%, rgba(147,197,253,0) 60%), linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%); }
  .pvc-ss-sit-corpo { display: flex; flex-direction: column; align-items: center; gap: 8px; padding-top: 4px; }
  .pvc-ss-sit-ic { width: 60px; height: 60px; border-radius: 50%; background: #dbeafe; display: flex; align-items: center; justify-content: center; }
  .pvc-ss-sit-txt { font-weight: 800; color: #475569; text-transform: uppercase; letter-spacing: .6px; font-size: .95rem; text-align: center; }
  .pvc-ss-relogio { font-size: 2.6rem; font-weight: 900; color: #1e40af; letter-spacing: 1px; font-variant-numeric: tabular-nums; }
  .pvc-grade { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; }
  .pvc-card { background: #fff; border: 2px solid transparent; border-radius: 20px; display: flex; flex-direction: row; align-items: center; gap: 16px; padding: 18px 16px 18px 18px; text-align: left; position: relative; cursor: pointer; box-shadow: 0 4px 16px rgba(15,23,42,.06); font-family: inherit; color: #0f172a; min-height: 112px; transition: transform .12s ease, box-shadow .12s ease; }
  .pvc-card:active { transform: scale(.98); }
  .pvc-card:hover { box-shadow: 0 8px 22px rgba(15,23,42,.10); }
  .pvc-card .pvc-ic { width: 66px; height: 66px; border-radius: 18px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .pvc-card-txt { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
  .pvc-card b { font-size: 1.12rem; font-weight: 800; line-height: 1.2; }
  .pvc-card span.pvc-sub { color: #64748b; font-size: .9rem; line-height: 1.3; }
  .pvc-card.pvc-agora { border-color: #dc2626; background: #fff5f5; box-shadow: 0 0 0 4px rgba(220,38,38,.12); }
  .pvc-selo { position: absolute; top: -10px; right: 14px; background: #dc2626; color: #fff; font-weight: 800; font-size: .7rem; padding: 4px 10px; border-radius: 999px; letter-spacing: .5px; }
  .pvc-barra-nome { display: flex; align-items: center; gap: 8px; min-width: 0; }
  .pvc-voltar-sub { background: #e0edff; border: none; color: #1d4ed8; border-radius: 12px; padding: 10px 16px; font-weight: 800; font-size: 1rem; cursor: pointer; font-family: inherit; white-space: nowrap; display: inline-flex; align-items: center; gap: 6px; }
  .pvc-lista-sessoes { display: flex; flex-direction: column; gap: 10px; }
  .pvc-sessao-linha { width: 100%; text-align: left; background: #fff; border: 2px solid transparent; border-radius: 16px; padding: 14px 16px; cursor: pointer; font-family: inherit; color: #0f172a; display: flex; align-items: center; gap: 14px; box-shadow: 0 3px 12px rgba(15,23,42,.05); }
  .pvc-sessao-linha:active { transform: scale(.99); }
  .pvc-sessao-linha.pvc-viva { border-color: #fecaca; background: #fffafa; }
  .pvc-sessao-data { width: 58px; flex-shrink: 0; text-align: center; background: #eff6ff; color: #1d4ed8; border-radius: 12px; padding: 7px 0; line-height: 1.1; }
  .pvc-viva .pvc-sessao-data { background: #fee2e2; color: #b91c1c; }
  .pvc-sessao-data b { display: block; font-size: 1.35rem; font-weight: 900; }
  .pvc-sessao-data small { font-size: .72rem; font-weight: 800; text-transform: uppercase; }
  .pvc-sessao-tit { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; font-weight: 800; font-size: 1rem; line-height: 1.3; }
  .pvc-sessao-info { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; margin-top: 5px; color: #64748b; font-size: .86rem; }
  .pvc-chip { font-weight: 800; font-size: .74rem; padding: 3px 9px; border-radius: 999px; }
  .pvc-filtros { display: flex; gap: 6px; flex-wrap: wrap; margin: 4px 0 14px; }
  .pvc-filtro { border: 1px solid #e2e8f0; background: #fff; color: #475569; border-radius: 999px; padding: 7px 14px; font-weight: 700; font-size: .9rem; cursor: pointer; font-family: inherit; }
  .pvc-filtro.ativo { background: #2563eb; border-color: #2563eb; color: #fff; }
  .pvc-cab-sessao { background: #fff; border-radius: 18px; padding: 16px 18px; box-shadow: 0 3px 12px rgba(15,23,42,.05); display: flex; flex-direction: column; gap: 12px; }
  .pvc-numeros { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 8px; }
  .pvc-numeros > div { border-radius: 12px; padding: 8px 6px; text-align: center; }
  .pvc-numeros b { display: block; font-size: 1.45rem; font-weight: 900; }
  .pvc-numeros small { font-weight: 700; font-size: .78rem; }
  .pvc-materia { background: #fff; border-radius: 16px; padding: 14px 16px; box-shadow: 0 3px 12px rgba(15,23,42,.05); display: flex; gap: 14px; border-left: 5px solid #94a3b8; }
  @media (max-width: 760px) {
    .pvc-numeros { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .pvc-materia { flex-direction: column; gap: 8px; }
  }
  @media (max-width: 760px) {
    .pvc-topo.pvc-topo-comp { padding: 10px 14px 14px; }
    .pvc-topo-comp .pvc-topo-brasao { width: 42px; height: 48px; }
    .pvc-topo-comp .pvc-topo-div { min-height: 34px; }
    .pvc-topo-comp .pvc-topo-cidade { font-size: 1.15rem; }
    .pvc-topo-quem b { font-size: .8rem; }
    .pvc-topo-quem small { font-size: .7rem; }
    .pvc-barra { padding: 12px 14px 4px; gap: 8px; }
    .pvc-abas { padding: 0 6px; gap: 0; }
    .pvc-aba { flex-direction: column; gap: 4px; padding: 8px 10px 7px; font-size: .74rem; }
    .pvc-aba-ic { width: 32px; height: 32px; }
    .pvc-barra-so-atualizar { display: none; }
    .pvc-rot-longo { display: none; }
    .pvc-rot-curto { display: inline; }
    .pvc-barra-titulo { font-size: 1.25rem; }
    .pvc-bt { padding: 9px 12px; font-size: .92rem; }
    .pvc-ss { padding: 10px 14px 20px; gap: 12px; }
    .pvc-ss-perfil { padding: 14px; gap: 14px; }
    .pvc-ss-foto { width: 88px; height: 88px; }
    .pvc-ss-nome { font-size: 1.2rem; }
    .pvc-ss-desc { font-size: .88rem; }
    .pvc-ss-stats { gap: 10px; }
    .pvc-ss-stat { padding: 12px; gap: 10px; flex-direction: column; align-items: flex-start; }
    .pvc-ss-stat-ic { width: 48px; height: 44px; }
    .pvc-ss-val { font-size: 1.7rem; }
    .pvc-ss-relogio { font-size: 2rem; }
    .pvc-topo { padding: 16px 16px 22px; gap: 10px; }
    .pvc-topo-camara { gap: 10px; }
    .pvc-topo-brasao { width: 52px; height: 60px; }
    .pvc-topo-div { min-height: 40px; }
    .pvc-topo-pre { font-size: .66rem; letter-spacing: 1px; }
    .pvc-topo-cidade { font-size: 1.3rem; }
    .pvc-topo-perfil { gap: 8px; }
    .pvc-topo-circ { width: 48px; height: 48px; border-width: 2px; }
    .pvc-inicio-corpo { padding: 10px 14px 18px; }
    .pvc-ola { font-size: .92rem; }
    .pvc-ola-nome { font-size: 1.12rem; }
    .pvc-ola-sub { font-size: .9rem; }
    .pvc-topo.pvc-topo-hero { padding-bottom: 48px; }
    .pvc-onda { height: 34px; }
    .pvc-ola-sessao { font-size: .85rem; padding: 7px 12px; }
    .pvc-avisos { right: 0; width: min(290px, calc(100vw - 28px)); }
    .pvc-grade { gap: 10px; }
    .pvc-card { gap: 10px; padding: 12px 8px 12px 10px; min-height: 96px; border-radius: 16px; }
    .pvc-card .pvc-ic { width: 46px; height: 46px; border-radius: 13px; }
    .pvc-card .pvc-ic svg { width: 24px; height: 24px; }
    .pvc-card b { font-size: .95rem; }
    .pvc-card span.pvc-sub { font-size: .76rem; }
  }
  @media (max-width: 480px) {
    .pvc-grade { grid-template-columns: minmax(0, 1fr); }
    .pvc-topo-quem { display: none; }
    .pvc-topo-pre { font-size: .6rem; }
    .pvc-barra .pvc-bt[title="Atualizar"] { display: none; }
    .pv-root.pv-cards .pv-botoes-voto { gap: 8px; }
    .pv-root.pv-cards .pv-botoes-voto > .pv-btn-voto { flex: 1 1 0; min-width: 0; font-size: .92rem; gap: 9px; padding: 16px 2px; letter-spacing: 0; border-radius: 16px; }
    .pv-root.pv-cards .pv-btn-voto::before { width: 48px; height: 48px; background-size: 26px; }
    .pvc-card { min-height: 84px; }
  }
  @media (max-width: 760px) {
    .pvc-barra-nome .pvc-barra-txt b { font-size: .92rem !important; white-space: normal !important; display: -webkit-box !important; -webkit-line-clamp: 2; -webkit-box-orient: vertical; line-height: 1.15; }
    .pvc-barra-nome .pvc-barra-txt small { font-size: .74rem; }
    .pvc-barra .pvc-bt { padding-left: 10px; padding-right: 10px; font-size: .88rem; gap: 6px; flex-shrink: 0; }
  }

  /* Como cada vereador votou (PLENARIUM:VOTOS_AO_VIVO) */
  .pvc-vv { background: #fff; border: 1px solid #e2e8f0; border-radius: 18px; padding: 16px; box-shadow: 0 4px 16px rgba(15,23,42,.05); margin-top: 12px; }
  .pvc-vv-cab { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 12px; }
  .pvc-vv-tit { font-size: 1.08rem; font-weight: 800; color: #0f172a; }
  .pvc-vv-sub { font-size: .86rem; color: #64748b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 2px; }
  .pvc-vv-selo { flex-shrink: 0; display: inline-flex; align-items: center; gap: 7px; font-size: .74rem; font-weight: 900; letter-spacing: .6px; padding: 6px 11px; border-radius: 999px; background: #f1f5f9; color: #475569; }
  .pvc-vv-selo.vivo { background: #fee2e2; color: #b91c1c; }
  .pvc-vv-selo.ok { background: #dcfce7; color: #15803d; }
  .pvc-vv-selo.nao { background: #fee2e2; color: #b91c1c; }
  .pvc-vv-ponto { width: 8px; height: 8px; border-radius: 50%; background: #dc2626; animation: pulse 1.4s ease infinite; }
  .pvc-vv-resumo { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 14px; }
  .pvc-vv-chip { font-size: .78rem; font-weight: 800; letter-spacing: .3px; padding: 6px 11px; border-radius: 10px; }
  .pvc-vv-chip b { font-size: .95rem; margin-left: 4px; }
  .pvc-vv-grade { display: grid; grid-template-columns: repeat(auto-fill, minmax(102px, 1fr)); gap: 10px; }
  .pvc-vv-card { border: 2px solid #e2e8f0; border-radius: 14px; overflow: hidden; background: #fff; transition: border-color .3s, transform .3s; container-type: inline-size; min-width: 0; }
  .pvc-vv-card.votou { animation: pvcVotou .45s ease; }
  @keyframes pvcVotou { from { transform: scale(.94); } to { transform: none; } }
  .pvc-vv-foto { aspect-ratio: 4 / 4.4; background: #f1f5f9; display: flex; align-items: center; justify-content: center; overflow: hidden; color: #94a3b8; font-weight: 800; font-size: 1.4rem; }
  .pvc-vv-foto img { width: 100%; height: 100%; object-fit: cover; object-position: center top; }
  .pvc-vv-info { padding: 8px 8px 9px; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 1px; }
  .pvc-vv-info b { font-size: .86rem; color: #0f172a; max-width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .pvc-vv-info small { font-size: .7rem; color: #94a3b8; margin-bottom: 5px; }
  .pvc-vv-voto { display: inline-flex; align-items: center; justify-content: center; gap: 5px; width: 100%; box-sizing: border-box; border: 1.5px solid; border-radius: 9px; padding: 4px 4px; font-size: .7rem; font-weight: 900; letter-spacing: .3px; white-space: nowrap; overflow: hidden; }
  .pvc-vv-voto svg { flex-shrink: 0; }
  .pvc-vv-voto span { overflow: hidden; text-overflow: ellipsis; }
  @container (max-width: 132px) { .pvc-vv-voto { font-size: .62rem; letter-spacing: 0; gap: 3px; padding: 4px 2px; } .pvc-vv-voto svg { width: 13px; height: 13px; } }
  @container (max-width: 112px) { .pvc-vv-voto svg { display: none; } .pvc-vv-voto { font-size: .6rem; } }
  /* a tela da Votacao rola no celular (a grade de votos pode passar da altura da tela) */
  .pv-root.pv-cards .pv-main > div { min-height: 0; }
  .pv-root.pv-cards .pv-votacao { min-height: 0; overflow-y: auto; -webkit-overflow-scrolling: touch; }
  .pvc-vv-secreta { background: #eff6ff; color: #1d4ed8; border-radius: 12px; padding: 12px 14px; font-weight: 600; font-size: .95rem; }
  .pvc-vv-rodape { margin-top: 12px; font-size: .78rem; color: #94a3b8; text-align: center; }
  @media (min-width: 1025px) and (hover: hover) and (pointer: fine) { .pvc-vv-grade { grid-template-columns: repeat(auto-fill, minmax(132px, 1fr)); } }
  /* ---------- Computador: barra no alto + menu lateral + painel (PLENARIUM:CARDS v16) ---------- */
  .pvc-so-pc, .pvc-dash, .pvc-busca { display: none; }
  @media (min-width: 1025px) and (hover: hover) and (pointer: fine) {
    .pvc-so-pc { display: flex; }
    .pvc-nao-pc { display: none !important; }
    body.pvc-topo-on .pv-root.pv-cards .pv-main { padding: 76px 0 0 248px !important; }
    .pvc-topo, .pvc-topo.pvc-topo-hero, .pvc-topo.pvc-topo-comp { position: fixed; top: var(--pvc-y, 0px); left: 0; right: 0; height: 76px; z-index: 60; padding: 0 26px; gap: 0; justify-content: center; }
    .pvc-topo-hero .pvc-topo-extra, .pvc-topo .pvc-onda { display: none !important; }
    .pvc-topo .pvc-topo-linha { gap: 18px; }
    .pvc-topo .pvc-topo-camara { gap: 14px; flex-shrink: 0; }
    .pvc-topo .pvc-topo-brasao, .pvc-topo-comp .pvc-topo-brasao, .pvc-topo-hero .pvc-topo-brasao { width: 44px; height: 50px; }
    .pvc-topo .pvc-topo-div, .pvc-topo-comp .pvc-topo-div, .pvc-topo-hero .pvc-topo-div { min-height: 40px; background: rgba(255,255,255,.22); }
    .pvc-topo .pvc-topo-pre, .pvc-topo-hero .pvc-topo-pre { font-size: .72rem; letter-spacing: 1.6px; }
    .pvc-topo .pvc-topo-cidade, .pvc-topo-comp .pvc-topo-cidade, .pvc-topo-hero .pvc-topo-cidade { font-size: 1.4rem; }
    .pvc-topo .pvc-topo-circ, .pvc-topo-hero .pvc-topo-circ { width: 46px; height: 46px; border-width: 2px; }
    .pvc-topo .pvc-topo-perfil { gap: 12px; }
    .pvc-pc-marca { align-items: center; gap: 10px; flex-shrink: 0; }
    .pvc-pc-marca img { height: 40px; width: auto; object-fit: contain; mix-blend-mode: screen; }
    .pvc-pc-marca span { display: flex; flex-direction: column; line-height: 1; color: #fff; }
    .pvc-pc-marca b { font-size: 1.22rem; font-weight: 500; letter-spacing: .8px; }
    .pvc-pc-marca small { font-size: .62rem; font-weight: 600; letter-spacing: 4.2px; opacity: .75; margin-top: 3px; text-align: center; }
    .pvc-busca { display: block; position: relative; flex: 0 1 300px; margin-left: auto; }
    .pvc-busca-campo { display: flex; align-items: center; gap: 10px; height: 44px; border-radius: 999px; padding: 0 16px; background: rgba(255,255,255,.09); border: 1px solid rgba(255,255,255,.14); color: rgba(255,255,255,.75); transition: background .15s, border-color .15s; }
    .pvc-busca-campo:focus-within { background: rgba(255,255,255,.15); border-color: rgba(147,197,253,.6); }
    .pvc-busca-campo input { flex: 1; min-width: 0; background: none; border: none; outline: none; color: #fff; font-family: inherit; font-size: .95rem; }
    .pvc-busca-campo input::-webkit-search-cancel-button { -webkit-appearance: none; display: none; }
    .pvc-busca-campo input::placeholder { color: rgba(255,255,255,.62); }
    .pvc-busca-res { position: absolute; top: calc(100% + 8px); left: 0; right: 0; min-width: 340px; background: #fff; color: #0f172a; border-radius: 16px; box-shadow: 0 18px 44px rgba(15,23,42,.25); padding: 8px; z-index: 70; max-height: 70vh; overflow-y: auto; }
    .pvc-busca-grupo { font-size: .72rem; font-weight: 800; letter-spacing: .6px; text-transform: uppercase; color: #94a3b8; padding: 8px 10px 4px; }
    .pvc-busca-item { width: 100%; display: flex; align-items: center; gap: 10px; background: none; border: none; border-radius: 10px; padding: 9px 10px; font-family: inherit; text-align: left; cursor: pointer; color: #0f172a; font-size: .92rem; }
    .pvc-busca-item:hover, .pvc-busca-item.sel { background: #f1f5f9; }
    .pvc-busca-item small { display: block; color: #64748b; font-size: .8rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .pvc-busca-vazio { padding: 12px 10px; color: #64748b; font-size: .9rem; }
    .pvc-topo .pvc-sino { width: 44px; height: 44px; }
    .pvc-topo .pvc-avisos { right: 64px; }
    /* menu lateral */
    .pvc-abas, .pvc-abas.pvc-abas { position: fixed !important; top: calc(var(--pvc-y, 0px) + 76px); left: 0; bottom: 0; width: 248px; z-index: 50; flex-direction: column; gap: 4px; padding: 18px 14px; background: #fff; border-right: 1px solid #e2e8f0; border-bottom: none; box-shadow: none; overflow-y: auto; }
    .pvc-abas .pvc-aba { width: 100%; flex-direction: row; gap: 12px; padding: 10px 12px; border: none; border-radius: 12px; font-size: .98rem; font-weight: 500; color: #334155; position: relative; }
    .pvc-abas .pvc-aba:hover { background: #f1f5f9; }
    .pvc-abas .pvc-aba.ativa { background: #eaf1ff; color: #1d4ed8; font-weight: 700; }
    .pvc-abas .pvc-aba.ativa::before { content: ''; position: absolute; left: -14px; top: 8px; bottom: 8px; width: 4px; border-radius: 0 4px 4px 0; background: #2563eb; }
    .pvc-abas .pvc-aba-ic { width: 24px; height: 24px; background: none !important; border-radius: 0; }
    .pvc-abas .pvc-aba-ic svg { stroke: currentColor !important; width: 21px; height: 21px; }
    .pvc-abas .pvc-rot-curto { display: none; }
    .pvc-abas .pvc-rot-longo { display: inline; }
    .pvc-abas .pvc-aba-ponto { top: -2px; right: -4px; }
    .pvc-abas [data-aba="inicio"] { order: 1; } .pvc-abas [data-aba="votacao"] { order: 2; } .pvc-abas [data-aba="projetos"] { order: 6; }
    .pvc-abas [data-aba="todos"] { order: 7; } .pvc-abas [data-aba="requerimento"] { order: 8; } .pvc-abas [data-aba="historico"] { order: 9; } .pvc-abas [data-aba="presencas"] { order: 10; }
    /* PLENARIUM:ORDEM_MENU -- Inicio sempre primeiro; Leituras, Comissoes e Ata logo depois da Votacao */
    .pvc-abas [data-aba="leituras"] { order: 3; } .pvc-abas [data-aba="comissoes"] { order: 4; } .pvc-abas [data-aba="ata"] { order: 5; } .pvc-abas [data-aba="tribuna"] { order: 2; }
    /* Inicio: painel no lugar dos cards */
    .pvc-inicio-tela .pvc-grade { display: none; }
    .pvc-inicio-corpo { padding: 22px 26px 18px; }
    .pvc-dash { display: grid; grid-template-columns: minmax(0, 1fr) minmax(320px, 400px); gap: 20px; align-items: stretch; }
    .pvc-dash-card { background: #fff; border: 1px solid #e8edf5; border-radius: 18px; box-shadow: 0 4px 18px rgba(15,23,42,.05); padding: 20px 22px; min-width: 0; }
    .pvc-hero { position: relative; overflow: hidden; border-radius: 18px; min-height: 230px; padding: 36px 40px; color: #fff; display: flex; flex-direction: column; justify-content: center;
      background: radial-gradient(70% 120% at 85% 10%, rgba(59,130,246,.38) 0%, rgba(59,130,246,0) 60%), linear-gradient(120deg, #071a42 0%, #0c2a6b 55%, #12398c 100%); box-shadow: 0 14px 34px rgba(8,30,80,.22); }
    .pvc-hero-arte { position: absolute; right: 0; bottom: 0; height: 100%; width: 40%; pointer-events: none; }
    .pvc-hero-ola { font-size: 1.6rem; font-weight: 400; opacity: .95; position: relative; }
    .pvc-hero-nome { font-size: 2.15rem; font-weight: 800; letter-spacing: -.01em; line-height: 1.15; margin-top: 2px; position: relative; max-width: 74%; }
    .pvc-hero-txt { margin: 14px 0 0; max-width: 440px; font-size: 1.05rem; line-height: 1.5; color: rgba(255,255,255,.78); position: relative; }
    .pvc-hero-linha { width: 48px; height: 3px; border-radius: 3px; background: #3b82f6; margin-top: 20px; position: relative; }
    .pvc-ses-topo { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
    .pvc-ses-ponto { width: 18px; height: 18px; border-radius: 50%; background: #dc2626; box-shadow: 0 0 0 4px #fee2e2; flex-shrink: 0; animation: pulse 1.6s ease infinite; }
    .pvc-ses-ponto.off { background: #94a3b8; box-shadow: 0 0 0 4px #f1f5f9; animation: none; }
    .pvc-ses-rot { font-weight: 800; color: #dc2626; font-size: 1.05rem; flex: 1; }
    .pvc-ses-rot.off { color: #475569; }
    .pvc-selo-vivo { background: #dcfce7; color: #15803d; font-weight: 800; font-size: .74rem; letter-spacing: .5px; padding: 5px 10px; border-radius: 8px; }
    .pvc-ses-tit { font-weight: 800; font-size: 1.1rem; margin-bottom: 10px; color: #0f172a; }
    .pvc-ses-info { display: flex; align-items: center; gap: 10px; color: #475569; font-size: .95rem; margin: 7px 0; }
    .pvc-ses-info svg { flex-shrink: 0; }
    .pvc-ses-bt { width: 100%; margin-top: 16px; height: 46px; border: none; border-radius: 12px; display: flex; align-items: center; justify-content: center; gap: 10px; font-family: inherit; font-weight: 700; font-size: 1rem; color: #fff; background: #dc2626; cursor: pointer; box-shadow: 0 8px 18px rgba(220,38,38,.25); }
    .pvc-ses-bt:hover { background: #c81e1e; }
    .pvc-ses-bt.claro { background: #eff6ff; color: #1d4ed8; box-shadow: none; }
    .pvc-dash-cab { display: flex; align-items: center; gap: 12px; padding-bottom: 12px; border-bottom: 1px solid #eef2f7; margin-bottom: 4px; }
    .pvc-dash-cab b { flex: 1; font-size: 1.05rem; color: #0f172a; }
    .pvc-dash-link { background: none; border: none; font-family: inherit; color: #2563eb; font-weight: 700; font-size: .9rem; cursor: pointer; display: inline-flex; align-items: center; gap: 2px; }
    .pvc-prox { display: flex; align-items: center; gap: 18px; padding: 12px 0; border-bottom: 1px solid #f1f5f9; }
    .pvc-prox:last-child { border-bottom: none; }
    .pvc-prox-data { width: 62px; height: 60px; border-radius: 12px; background: #f1f5f9; display: flex; flex-direction: column; align-items: center; justify-content: center; flex-shrink: 0; color: #0f172a; }
    .pvc-prox-data b { font-size: 1.45rem; font-weight: 800; line-height: 1; }
    .pvc-prox-data small { font-size: .72rem; font-weight: 800; margin-top: 3px; }
    .pvc-prox-txt { flex: 1; min-width: 0; }
    .pvc-prox-txt b { display: block; font-size: 1rem; color: #0f172a; margin-bottom: 6px; }
    .pvc-prox-meta { display: flex; align-items: center; gap: 16px; color: #475569; font-size: .86rem; flex-wrap: wrap; }
    .pvc-prox-meta span { display: inline-flex; align-items: center; gap: 6px; }
    .pvc-tag { font-size: .74rem; font-weight: 800; letter-spacing: .4px; padding: 6px 12px; border-radius: 8px; flex-shrink: 0; }
    .pvc-tag.hoje { background: #dcfce7; color: #15803d; } .pvc-tag.prox { background: #f1f5f9; color: #334155; } .pvc-tag.ag { background: #eff6ff; color: #1d4ed8; }
    .pvc-doc { width: 100%; display: flex; align-items: center; gap: 12px; background: none; border: none; border-bottom: 1px solid #f1f5f9; padding: 9px 2px; font-family: inherit; text-align: left; cursor: pointer; color: #0f172a; }
    .pvc-doc:last-child { border-bottom: none; }
    .pvc-doc:hover { background: #f8fafc; }
    .pvc-doc-ic { width: 38px; height: 38px; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .pvc-doc-txt { flex: 1; min-width: 0; }
    .pvc-doc-txt b { display: block; font-size: .93rem; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .pvc-doc-txt small { color: #64748b; font-size: .8rem; }
    .pvc-dash-vazio { color: #64748b; font-size: .92rem; padding: 18px 2px 8px; }
    .pvc-inicio-tela .pvc-assinatura { padding-top: 18px; }
  }
`;

const TITULOS = {
  votacao: 'Votação', ordem: 'Ordem do Dia', historico: 'Sessões', /* PLENARIUM:SESSAO_ELEICAO */ projetos: 'Meus Projetos',
  todos: 'Todos os Projetos', documentos: 'Central de Documentos' /* PLENARIUM:CENTRAL_DOCUMENTOS */, requerimento: 'Novo Requerimento', presenca: 'Presença', presencas: 'Presenças',
  controle: 'Controles da Votação', cronometro: 'Cronômetro', justificativas: 'Justificar Falta',
  leituras: 'Leituras da Mesa', // PLENARIUM:LEITURAS
  comissoes: 'Comissões', // PLENARIUM:COMISSOES
  ata: 'Ata Anterior', // PLENARIUM:ATA_RETIFICACAO
  tribuna: 'Uso da Tribuna' // PLENARIUM:TRIBUNA
};
const exibCurtoV = (v) => { const n = String((v && (v.nomeParlamentar || v.nome)) || '').trim().split(/\s+/); return n.length > 2 ? `${n[0]} ${n[n.length - 1]}` : n.join(' '); };
const nomeV = (v) => (v ? (v.nomeParlamentar || v.nome) : '');
const iniciais = (nome) => String(nome || '?').replace(/^Ver(\.ª|\.)\s*/i, '').split(' ').filter(Boolean).map(p => p[0]).slice(0, 2).join('').toUpperCase();
// ---------------------------------------------------------------------
// Tema claro/escuro do painel do vereador (PLENARIUM:TEMA)
// Escolha guardada no aparelho: 'claro' (padrao), 'escuro' ou 'auto'
// (segue o celular/computador). No escuro, as cores claras das folhas de
// estilo e dos estilos das telas viram tons escuros equivalentes, sem
// mexer no resto do sistema: so vale enquanto o painel esta aberto.
// ---------------------------------------------------------------------
const TEMA_CHAVE = 'plenarium:tema';
const TEMA_ATR = 'data-pvc-tema';
const TEMA_SEL = 'html[data-pvc-tema="escuro"]';
export function lerTema() {
  try { const t = window.localStorage.getItem(TEMA_CHAVE); return t === 'escuro' || t === 'auto' ? t : 'claro'; } catch (e) { return 'claro'; }
}
const temaEst = { usos: 0, ativo: false, obs: null, folha: null, regs: new WeakMap(), els: new Set(), timer: null, mq: null, ouvindo: false, gerando: false };
const COR_NOMES = { white: [255, 255, 255], black: [0, 0, 0] };
function lerCor(t) {
  t = t.trim().toLowerCase();
  if (COR_NOMES[t]) { const [r, g, b] = COR_NOMES[t]; return { r, g, b, a: 1 }; }
  if (t[0] === '#') {
    let h = t.slice(1);
    if (h.length === 3 || h.length === 4) h = h.split('').map(x => x + x).join('');
    if (h.length !== 6 && h.length !== 8) return null;
    const n = (i) => parseInt(h.slice(i, i + 2), 16);
    return { r: n(0), g: n(2), b: n(4), a: h.length === 8 ? n(6) / 255 : 1 };
  }
  const m = t.match(/^rgba?\(([^)]*)\)$/);
  if (!m) return null;
  const p = m[1].split(/[\s,/]+/).filter(Boolean);
  if (p.length < 3) return null;
  const v = (x) => (x.endsWith('%') ? parseFloat(x) * 2.55 : parseFloat(x));
  const a = p[3] === undefined ? 1 : (p[3].endsWith('%') ? parseFloat(p[3]) / 100 : parseFloat(p[3]));
  return { r: v(p[0]), g: v(p[1]), b: v(p[2]), a };
}
const lim = (x) => Math.max(0, Math.min(255, Math.round(x)));
function hslRgb(h, s, l) {
  const k = (n) => (n + h / 30) % 12; const a = s * Math.min(l, 1 - l);
  const f = (n) => l - a * Math.max(-1, Math.min(k(n) - 3, 9 - k(n), 1));
  return [f(0) * 255, f(8) * 255, f(4) * 255];
}
function rgbHsl(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  const mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2; let h = 0, s = 0;
  if (mx !== mn) {
    const d = mx - mn; s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);
    h = mx === r ? ((g - b) / d + (g < b ? 6 : 0)) : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; h *= 60;
  }
  return [h, s, l];
}
function interp(pts, y) { // pts: [[y, valor], ...] com y decrescente
  if (y >= pts[0][0]) return pts[0][1];
  for (let i = 1; i < pts.length; i++) if (y >= pts[i][0]) { const [y0, v0] = pts[i - 1], [y1, v1] = pts[i]; return v1 + (v0 - v1) * (y - y1) / (y0 - y1); }
  return pts[pts.length - 1][1];
}
const FUNDO_PTS = [[1, 0.155], [0.985, 0.125], [0.965, 0.085], [0.94, 0.11], [0.9, 0.2], [0.8, 0.26], [0.72, 0.3]];
function corEscura(cat, c) {
  if (!c || c.a < 0.85) return null;
  const y = (0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b) / 255;
  if (cat === 'tx') {
    const [h, s, l] = rgbHsl(c.r, c.g, c.b);
    if (l > 0.6) return null;
    const [r, g, b] = hslRgb(h, Math.min(s, 0.85), Math.max(0.62, 0.93 - 0.45 * l));
    return [r, g, b, c.a];
  }
  if (y < 0.72) return null; // cores fortes (botoes, selos) ficam como estao
  const L = cat === 'bd' ? Math.min(0.3, 0.2 + (1 - y) * 0.35) : interp(FUNDO_PTS, y);
  const base = hslRgb(220, 0.26, L);
  const m = (c.r + c.g + c.b) / 3; const d = [c.r - m, c.g - m, c.b - m];
  const maior = Math.max(1, ...d.map(Math.abs)); const k = Math.min(cat === 'bd' ? 2 : 2.6, (cat === 'bd' ? 56 : 66) / maior);
  return [base[0] + d[0] * k, base[1] + d[1] * k, base[2] + d[2] * k, c.a];
}
const COR_RE = /#[0-9a-fA-F]{3,8}\b|rgba?\([^)]*\)|\b(?:white|black)\b/g;
function valorEscuro(cat, v) {
  if (!v || (v.indexOf('var(') >= 0 && !/#|rgb|white|black/i.test(v))) return null;
  let mudou = false;
  const troca = (s) => s.replace(COR_RE, (t) => {
    const e = corEscura(cat, lerCor(t)); if (!e) return t; mudou = true;
    const [r, g, b, a] = e; return a < 1 ? `rgba(${lim(r)}, ${lim(g)}, ${lim(b)}, ${Math.round(a * 1000) / 1000})` : `rgb(${lim(r)}, ${lim(g)}, ${lim(b)})`;
  });
  // nao mexe em imagens embutidas (url(...)), so nas cores
  const partes = v.split(/(url\((?:"[^"]*"|'[^']*'|[^)]*)\))/g);
  const out = partes.map((s, i) => (i % 2 ? s : troca(s))).join('');
  return mudou ? out : null;
}
function catDe(p) {
  if (p === 'background-color' || p === 'background-image' || p === 'fill') return 'bg';
  if (p === 'color' || p === 'stroke' || p === 'caret-color') return 'tx';
  if (/^border(-(top|right|bottom|left|block-start|block-end|inline-start|inline-end))?-color$/.test(p) || p === 'outline-color') return 'bd';
  if (p.startsWith('--')) {
    if (/texto|cinza-escuro|cinza-medio/.test(p)) return 'tx';
    if (/fundo|branco|-bg|claro/.test(p)) return 'bg';
    if (/^--cinza$/.test(p)) return 'bd';
  }
  return null;
}
function dividirSel(s) {
  const out = []; let nivel = 0, ini = 0;
  for (let i = 0; i < s.length; i++) { const ch = s[i]; if (ch === '(' || ch === '[') nivel++; else if (ch === ')' || ch === ']') nivel--; else if (ch === ',' && !nivel) { out.push(s.slice(ini, i)); ini = i + 1; } }
  out.push(s.slice(ini)); return out.map(x => x.trim()).filter(Boolean);
}
function prefixar(sel) {
  return dividirSel(sel).map(s => {
    if (/^:root\b/.test(s)) return TEMA_SEL + s.slice(5);
    if (/^html\b/.test(s)) return TEMA_SEL + s.slice(4);
    if (s[0] === '[') return `${TEMA_SEL}${s}, ${TEMA_SEL} ${s}`;
    return `${TEMA_SEL} ${s}`;
  }).join(', ');
}
function percorrerRegras(regras, out) {
  for (const r of Array.from(regras || [])) {
    if (r.selectorText !== undefined && r.style) {
      const st = r.style; const dec = [];
      for (let i = 0; i < st.length; i++) {
        const p = st[i]; const cat = catDe(p); if (!cat) continue;
        const v = valorEscuro(cat, st.getPropertyValue(p)); if (v) dec.push(`${p}: ${v}${st.getPropertyPriority(p) ? ' !important' : ''}`);
      }
      if (dec.length) out.push(`${prefixar(r.selectorText)} { ${dec.join('; ')} }`);
    } else if (r.media && r.cssRules) {
      const dentro = []; percorrerRegras(r.cssRules, dentro);
      if (dentro.length) out.push(`@media ${r.media.mediaText} { ${dentro.join('\n')} }`);
    } else if (r.conditionText && r.cssRules) {
      const dentro = []; percorrerRegras(r.cssRules, dentro);
      if (dentro.length) out.push(`@supports ${r.conditionText} { ${dentro.join('\n')} }`);
    }
  }
}
const TEMA_FIXO = `
  ${TEMA_SEL} { color-scheme: dark; }
  ${TEMA_SEL} body { background: #0c1424; }
  ${TEMA_SEL} .pvc-topo { background: radial-gradient(120% 140% at 85% -20%, rgba(96,165,250,.32) 0%, rgba(96,165,250,0) 55%), linear-gradient(120deg, #081d4d 0%, #0f3a8c 55%, #1650b8 100%); }
  ${TEMA_SEL} .pvc-topo-circ { border-color: #fff; }
  @media (min-width: 1025px) and (hover: hover) and (pointer: fine) { ${TEMA_SEL} .pvc-topo { background: radial-gradient(90% 160% at 100% -40%, rgba(56,97,180,.35) 0%, rgba(56,97,180,0) 60%), linear-gradient(115deg, #071226 0%, #0c1c3d 50%, #11285a 100%); } }
  ${TEMA_SEL} .pvc-ola-sessao { background: #fff; color: #b91c1c; }
  ${TEMA_SEL} .pv-root.pv-cards .pv-btn-voto { color: #fff; }
  ${TEMA_SEL} .pv-root.pv-cards .pv-btn-sim { background: linear-gradient(180deg, #2fd16d 0%, #16a34a 100%); }
  ${TEMA_SEL} .pv-root.pv-cards .pv-btn-nao { background: linear-gradient(180deg, #f8615f 0%, #dc2626 100%); }
  ${TEMA_SEL} .pv-root.pv-cards .pv-btn-abst { background: linear-gradient(180deg, #fcc73a 0%, #f59e0b 100%); }
`;
function gerarFolha() {
  const out = [];
  for (const sh of Array.from(document.styleSheets)) {
    if (sh.ownerNode && sh.ownerNode.id === 'pvc-tema-escuro') continue;
    let regras; try { regras = sh.cssRules; } catch (e) { continue; }
    percorrerRegras(regras, out);
  }
  return out.join('\n') + TEMA_FIXO;
}
function tratarEl(el) {
  if (!el || el.nodeType !== 1 || el.id === 'pvc-tema-escuro') return;
  const st = el.style; if (!st) return;
  let reg = temaEst.regs.get(el);
  const guardar = () => { if (!reg) { reg = {}; temaEst.regs.set(el, reg); temaEst.els.add(el); } return reg; };
  for (let i = 0; i < st.length; i++) {
    const p = st[i]; const cat = catDe(p); if (!cat || p.startsWith('--')) continue;
    const v = st.getPropertyValue(p); if (!v) continue;
    const r = reg && reg[p]; if (r && r.m === v) continue;
    if (r && r.attr) { delete reg[p]; }
    const m = valorEscuro(cat, v); if (!m) continue;
    const pr = st.getPropertyPriority(p);
    st.setProperty(p, m, pr);
    guardar()[p] = { o: v, m: st.getPropertyValue(p), pr };
  }
  if (typeof SVGElement !== 'undefined' && el instanceof SVGElement) {
    for (const a of ['stroke', 'fill']) {
      const v = el.getAttribute(a); const r = reg && reg[a];
      if (r && r.attr && r.src === v) continue;
      if (r && !r.attr) continue; // ja veio de um style da tela
      const m = v ? valorEscuro(catDe(a), v) : null;
      if (!m) { if (r) { st.removeProperty(a); delete reg[a]; } continue; }
      st.setProperty(a, m);
      guardar()[a] = { attr: true, src: v, m: st.getPropertyValue(a) };
    }
  }
}
function tratarArvore(n) {
  if (!n || n.nodeType !== 1) return;
  tratarEl(n);
  n.querySelectorAll('[style], [stroke], [fill]').forEach(tratarEl);
}
function refazerFolha() {
  if (!temaEst.folha) return;
  const css = gerarFolha();
  if (temaEst.folha.textContent !== css) temaEst.folha.textContent = css;
}
function ligarEscuro() {
  if (temaEst.ativo) return;
  temaEst.ativo = true;
  const css = gerarFolha();
  const f = document.createElement('style'); f.id = 'pvc-tema-escuro'; f.textContent = css;
  document.head.appendChild(f); temaEst.folha = f;
  document.documentElement.setAttribute(TEMA_ATR, 'escuro');
  tratarArvore(document.body);
  temaEst.obs = new MutationObserver((muts) => {
    let folha = false;
    for (const m of muts) {
      if (m.type === 'attributes') { tratarEl(m.target); continue; }
      if (m.target && m.target.id !== 'pvc-tema-escuro' && (m.target.nodeName === 'STYLE' || m.target === document.head)) folha = true;
      for (const n of Array.from(m.addedNodes)) {
        if (n.nodeType !== 1) continue;
        if (n.nodeName === 'STYLE' || n.nodeName === 'LINK') { if (n.id !== 'pvc-tema-escuro') folha = true; continue; }
        if (n.querySelector && n.querySelector('style')) folha = true;
        tratarArvore(n);
      }
      for (const n of Array.from(m.removedNodes)) if (n.nodeName === 'STYLE' || n.nodeName === 'LINK') folha = true;
    }
    if (folha) refazerFolha();
    if (temaEst.els.size > 4000) temaEst.els.forEach(el => { if (!el.isConnected) temaEst.els.delete(el); });
  });
  temaEst.obs.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'stroke', 'fill'] });
}
function desligarEscuro() {
  if (!temaEst.ativo) return;
  temaEst.ativo = false;
  if (temaEst.obs) { temaEst.obs.disconnect(); temaEst.obs = null; }
  temaEst.els.forEach(el => {
    const reg = temaEst.regs.get(el); if (!reg) return;
    Object.keys(reg).forEach(p => {
      const r = reg[p];
      if (r.attr) { if (el.style.getPropertyValue(p) === r.m) el.style.removeProperty(p); }
      else if (el.style.getPropertyValue(p) === r.m) el.style.setProperty(p, r.o, r.pr);
    });
    temaEst.regs.delete(el);
  });
  temaEst.els.clear();
  if (temaEst.folha) { temaEst.folha.remove(); temaEst.folha = null; }
  document.documentElement.removeAttribute(TEMA_ATR);
}
function sincronizarTema() {
  if (!temaEst.mq && window.matchMedia) temaEst.mq = window.matchMedia('(prefers-color-scheme: dark)');
  const t = lerTema();
  const escuro = temaEst.usos > 0 && (t === 'escuro' || (t === 'auto' && !!(temaEst.mq && temaEst.mq.matches)));
  if (escuro) ligarEscuro(); else desligarEscuro();
}
export function definirTema(t) {
  try { window.localStorage.setItem(TEMA_CHAVE, t); } catch (e) { /* sem armazenamento: vale so agora */ }
  sincronizarTema();
  window.dispatchEvent(new Event('pvc:tema'));
}
function useTemaPainel() {
  React.useLayoutEffect(() => {
    temaEst.usos++; clearTimeout(temaEst.timer);
    if (!temaEst.ouvindo) {
      temaEst.ouvindo = true;
      if (!temaEst.mq && window.matchMedia) temaEst.mq = window.matchMedia('(prefers-color-scheme: dark)');
      const mudou = () => sincronizarTema();
      if (temaEst.mq) { if (temaEst.mq.addEventListener) temaEst.mq.addEventListener('change', mudou); else if (temaEst.mq.addListener) temaEst.mq.addListener(mudou); }
      window.addEventListener('storage', (e) => { if (e.key === TEMA_CHAVE) { sincronizarTema(); window.dispatchEvent(new Event('pvc:tema')); } });
    }
    sincronizarTema();
    return () => { temaEst.usos--; clearTimeout(temaEst.timer); temaEst.timer = setTimeout(sincronizarTema, 0); };
  }, []);
}
function useEscolhaTema() {
  const [t, setT] = useState(lerTema);
  useEffect(() => { const f = () => setT(lerTema()); window.addEventListener('pvc:tema', f); return () => window.removeEventListener('pvc:tema', f); }, []);
  return t;
}
function EscolhaTema() {
  const t = useEscolhaTema();
  const ops = [['claro', <Sun size={16} />, 'Claro'], ['escuro', <Moon size={16} />, 'Escuro'], ['auto', <Monitor size={16} />, 'Auto']];
  return (
    <div className="pvc-tema">
      <span className="pvc-tema-tit">Aparência</span>
      <div className="pvc-tema-ops" role="radiogroup" aria-label="Aparência">
        {ops.map(([k, ic, txt]) => (
          <button key={k} type="button" role="radio" aria-checked={t === k} className={`pvc-tema-op ${t === k ? 'ativa' : ''}`} onClick={() => definirTema(k)}>{ic}<span>{txt}</span></button>
        ))}
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
// Computador (PLENARIUM:CARDS v16): barra no alto com a marca Plenarium,
// busca, sino e foto; menu lateral; Inicio em forma de painel.
// Tablets e celulares nao usam nada disto (so aparece no computador).
// ---------------------------------------------------------------------
const MQ_PC = '(min-width: 1025px) and (hover: hover) and (pointer: fine)';
function useEhPC() {
  const [pc, setPc] = useState(() => !!(window.matchMedia && window.matchMedia(MQ_PC).matches));
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(MQ_PC); const f = () => setPc(mq.matches);
    if (mq.addEventListener) mq.addEventListener('change', f); else if (mq.addListener) mq.addListener(f);
    return () => { if (mq.removeEventListener) mq.removeEventListener('change', f); else if (mq.removeListener) mq.removeListener(f); };
  }, []);
  return pc;
}
// A barra do Presidente (status da sessao) fica acima: a barra do alto
// e o menu lateral comecam logo abaixo dela.
function useAlturaCabecalho() {
  useEffect(() => {
    const medir = () => {
      const cab = document.querySelector('.pv-cabecalho-camara');
      let y = 0;
      if (cab && cab.offsetParent !== null) y = Math.max(0, Math.round(cab.getBoundingClientRect().bottom));
      const ant = document.documentElement.style.getPropertyValue('--pvc-y');
      if (ant !== y + 'px') document.documentElement.style.setProperty('--pvc-y', y + 'px');
    };
    medir(); const t = setTimeout(medir, 400);
    window.addEventListener('resize', medir);
    return () => { clearTimeout(t); window.removeEventListener('resize', medir); };
  }, []);
}
// Os avisos do sino sao montados no Inicio; nas outras telas o sino mostra os ultimos.
let avisosGuardados = null;
const DATA_CURTA = (d) => { try { return new Date(d).toLocaleDateString('pt-BR'); } catch (e) { return ''; } };
const HORA = (d) => { try { return new Date(d).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }); } catch (e) { return ''; } };
const MES_ABR = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
const mesmoDia = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
function nomeMateria(p) {
  if (p.tipo === 'ATA_ANTERIOR' && p.ementa) return p.ementa;
  const tipo = TIPO_P[p.tipo] || 'Matéria';
  if (!p.numero) return tipo;
  if (/\//.test(p.numero)) return `${tipo} nº ${p.numero.replace(/^[A-Za-z.\s]+(?=\d)/, '')}`;
  return `${tipo} nº ${p.numero}${p.ano ? '/' + p.ano : ''}`;
}
const COR_DOC = { ATA_ANTERIOR: ['#dc2626', '#fee2e2'], PROJETO_LEI: ['#dc2626', '#fee2e2'], REQUERIMENTO: ['#16a34a', '#dcfce7'], INDICACAO: ['#2563eb', '#dbeafe'], MOCAO: ['#dc2626', '#fee2e2'] };
function abrirMateria(p, setAba) {
  if (p.temPrincipal) abrirDocumento(`/api/projetos-camara/${p.id}/principal`);
  else if (p.anexos && p.anexos.length) abrirDocumento(`/api/projetos-camara/anexo/${p.anexos[0].id}`);
  else setAba('todos');
}

function BuscaSistema({ setAba }) {
  const [q, setQ] = useState('');
  const [aberto, setAberto] = useState(false);
  const [res, setRes] = useState({ carregando: false, materias: [] });
  const [sel, setSel] = useState(0);
  const ref = useRef(null);
  const termo = q.trim();
  useEffect(() => {
    if (termo.length < 2) { setRes({ carregando: false, materias: [] }); return undefined; }
    let vivo = true; setRes(r => ({ ...r, carregando: true }));
    const t = setTimeout(() => {
      axios.get(`/api/projetos-camara?busca=${encodeURIComponent(termo)}`)
        .then(r => { if (vivo) setRes({ carregando: false, materias: ((r.data && r.data.projetos) || []).slice(0, 6) }); })
        .catch(() => { if (vivo) setRes({ carregando: false, materias: [] }); });
    }, 300);
    return () => { vivo = false; clearTimeout(t); };
  }, [termo]);
  useEffect(() => {
    if (!aberto) return undefined;
    const fora = (e) => { if (ref.current && !ref.current.contains(e.target)) setAberto(false); };
    document.addEventListener('pointerdown', fora);
    return () => document.removeEventListener('pointerdown', fora);
  }, [aberto]);
  const sem = (t) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const telas = termo ? ABAS.filter(([, rot]) => sem(rot.split('|')[0]).includes(sem(termo))) : [];
  const itens = [
    ...telas.map(([id, rot, ic]) => ({ k: 't' + id, ic: ic('#475569'), tit: rot.split('|')[0], sub: 'Abrir tela', ir: () => setAba(id) })),
    ...res.materias.map(p => ({ k: 'm' + p.id, ic: <FileText size={18} color="#2563eb" />, tit: nomeMateria(p), sub: p.ementa, ir: () => abrirMateria(p, setAba) }))
  ];
  const escolher = (it) => { setAberto(false); setQ(''); it.ir(); };
  const tecla = (e) => {
    if (e.key === 'Escape') { setAberto(false); e.currentTarget.blur(); }
    else if (e.key === 'ArrowDown') { e.preventDefault(); setSel(s => Math.min(s + 1, itens.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setSel(s => Math.max(s - 1, 0)); }
    else if (e.key === 'Enter' && itens[sel]) { e.preventDefault(); escolher(itens[sel]); }
  };
  return (
    <div className="pvc-busca" ref={ref}>
      <label className="pvc-busca-campo">
        <Search size={19} />
        <input type="search" value={q} placeholder="Pesquisar no sistema..." aria-label="Pesquisar no sistema"
          onChange={e => { setQ(e.target.value); setAberto(true); setSel(0); }} onFocus={() => setAberto(true)} onKeyDown={tecla} />
      </label>
      {aberto && termo.length >= 2 && (
        <div className="pvc-busca-res">
          {telas.length > 0 && <div className="pvc-busca-grupo">Telas</div>}
          {itens.map((it, i) => (
            <React.Fragment key={it.k}>
              {i === telas.length && res.materias.length > 0 && <div className="pvc-busca-grupo">Matérias e documentos</div>}
              <button type="button" className={`pvc-busca-item ${i === sel ? 'sel' : ''}`} onMouseEnter={() => setSel(i)} onClick={() => escolher(it)}>
                {it.ic}<span style={{ minWidth: 0, flex: 1 }}><span style={{ display: 'block', fontWeight: 600 }}>{it.tit}</span>{it.sub && <small>{it.sub}</small>}</span>
              </button>
            </React.Fragment>
          ))}
          {!itens.length && <div className="pvc-busca-vazio">{res.carregando ? 'Procurando...' : `Nada encontrado para "${termo}".`}</div>}
        </div>
      )}
    </div>
  );
}

function ArteTribuna() {
  return (
    <svg className="pvc-hero-arte" viewBox="0 0 420 240" preserveAspectRatio="xMaxYMax meet" aria-hidden="true">
      <defs>
        <linearGradient id="pvcBarra" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#60a5fa" stopOpacity=".35" /><stop offset="1" stopColor="#60a5fa" stopOpacity="0" /></linearGradient>
        <linearGradient id="pvcTrib" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#3b82f6" /><stop offset="1" stopColor="#1e40af" /></linearGradient>
        <linearGradient id="pvcOnda" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stopColor="#60a5fa" stopOpacity="0" /><stop offset=".5" stopColor="#60a5fa" stopOpacity=".45" /><stop offset="1" stopColor="#93c5fd" stopOpacity=".15" /></linearGradient>
      </defs>
      {[[40, 120], [78, 80], [116, 140], [154, 60], [300, 70], [338, 110], [376, 50]].map(([x, h], i) => <rect key={i} x={x} y={240 - h - 20} width="26" height={h} rx="3" fill="url(#pvcBarra)" />)}
      <path d="M0 214 C90 190 170 236 260 214 S380 186 420 200" stroke="url(#pvcOnda)" strokeWidth="2" fill="none" />
      <path d="M0 228 C110 206 190 246 280 226 S390 204 420 214" stroke="url(#pvcOnda)" strokeWidth="1.5" fill="none" />
      <g transform="translate(176 54)">
        <path d="M70 20 C64 6 50 2 40 8" stroke="#93c5fd" strokeWidth="4" fill="none" strokeLinecap="round" />
        <rect x="64" y="6" width="22" height="13" rx="6.5" transform="rotate(-30 75 12)" fill="#bfdbfe" />
        <path d="M40 8 L36 66" stroke="#93c5fd" strokeWidth="4" strokeLinecap="round" />
        <rect x="-6" y="62" width="100" height="16" rx="5" fill="#60a5fa" />
        <path d="M2 78 H86 L78 166 H10 Z" fill="url(#pvcTrib)" />
        <path d="M18 98 H70" stroke="#93c5fd" strokeOpacity=".55" strokeWidth="3" strokeLinecap="round" />
        <rect x="-14" y="164" width="116" height="10" rx="4" fill="#2563eb" />
      </g>
    </svg>
  );
}

function PainelInicioPC({ usuario, sessao, setAba }) {
  const [sessoes, setSessoes] = useState(null);
  const [docs, setDocs] = useState(null);
  useEffect(() => {
    let vivo = true;
    axios.get('/api/sessoes').then(r => { if (vivo) setSessoes(Array.isArray(r.data) ? r.data : []); }).catch(() => { if (vivo) setSessoes([]); });
    axios.get('/api/projetos-camara').then(r => {
      if (!vivo) return;
      const lista = ((r.data && r.data.projetos) || []).filter(p => p.temPrincipal || (p.anexos && p.anexos.length));
      lista.sort((a, b) => new Date(b.criadoEm) - new Date(a.criadoEm));
      setDocs(lista.slice(0, 5));
    }).catch(() => { if (vivo) setDocs([]); });
    return () => { vivo = false; };
  }, []);
  const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
  const proximas = (sessoes || []).filter(s => s.status === 'AGENDADA' && new Date(s.data) >= hoje)
    .sort((a, b) => new Date(a.data) - new Date(b.data)).slice(0, 3);
  const local = `Plenário da ${usuario?.camara?.nome || 'Câmara Municipal'}`;
  const dataLonga = (d) => { try { return new Date(d).toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) { return ''; } };
  const prox = proximas[0];
  return (
    <div className="pvc-dash">
      <div className="pvc-hero">
        <ArteTribuna />
        <div className="pvc-hero-ola">Olá,</div>
        <div className="pvc-hero-nome">{tratamentoDe(usuario)} {nomeV(usuario)}</div>
        <p className="pvc-hero-txt">Acesse pelo menu ao lado todas as funcionalidades do Plenarium Digital.</p>
        <span className="pvc-hero-linha" />
      </div>

      <div className="pvc-dash-card">
        {sessao ? (
          <>
            <div className="pvc-ses-topo"><span className="pvc-ses-ponto" /><span className="pvc-ses-rot">Sessão em andamento</span><span className="pvc-selo-vivo">AO VIVO</span></div>
            <div className="pvc-ses-tit">{sessao.titulo}</div>
            <div className="pvc-ses-info"><Calendar size={19} />{dataLonga(sessao.data)}</div>
            <div className="pvc-ses-info"><Clock size={19} />Início: {HORA(sessao.data)}</div>
            <div className="pvc-ses-info"><MapPin size={19} />{local}</div>
            <button type="button" className="pvc-ses-bt" onClick={() => setAba('votacao')}><Radio size={19} /> Acessar sessão</button>
          </>
        ) : (
          <>
            <div className="pvc-ses-topo"><span className="pvc-ses-ponto off" /><span className="pvc-ses-rot off">Nenhuma sessão em andamento</span></div>
            {prox ? (
              <>
                <div className="pvc-ses-tit" style={{ marginTop: 4 }}>Próxima: {prox.titulo}</div>
                <div className="pvc-ses-info"><Calendar size={19} />{dataLonga(prox.data)}</div>
                <div className="pvc-ses-info"><Clock size={19} />Início: {HORA(prox.data)}</div>
                <div className="pvc-ses-info"><MapPin size={19} />{local}</div>
              </>
            ) : <div className="pvc-ses-info">{sessoes === null ? 'Carregando...' : 'Nenhuma sessão agendada no momento.'}</div>}
            <button type="button" className="pvc-ses-bt claro" onClick={() => setAba('historico')}><History size={19} /> Ver sessões anteriores</button>
          </>
        )}
      </div>

      <div className="pvc-dash-card">
        <div className="pvc-dash-cab"><Calendar size={22} color="#2563eb" /><b>Próximas Sessões</b><button type="button" className="pvc-dash-link" onClick={() => setAba('historico')}>Ver todas <ChevronRight size={16} /></button></div>
        {sessoes === null ? <div className="pvc-dash-vazio">Carregando...</div>
          : !proximas.length ? <div className="pvc-dash-vazio">Nenhuma sessão agendada.</div>
          : proximas.map((s, i) => {
            const d = new Date(s.data); const ehHoje = mesmoDia(d, new Date());
            const primeiraFutura = !ehHoje && proximas.findIndex(x => !mesmoDia(new Date(x.data), new Date())) === i;
            return (
              <div key={s.id} className="pvc-prox">
                <div className="pvc-prox-data"><b>{String(d.getDate()).padStart(2, '0')}</b><small>{MES_ABR[d.getMonth()]}</small></div>
                <div className="pvc-prox-txt">
                  <b>{s.titulo}</b>
                  <div className="pvc-prox-meta"><span><Clock size={16} />{HORA(s.data)}</span><span><MapPin size={16} />{local}</span></div>
                </div>
                <span className={`pvc-tag ${ehHoje ? 'hoje' : primeiraFutura ? 'prox' : 'ag'}`}>{ehHoje ? 'HOJE' : primeiraFutura ? 'PRÓXIMA' : 'AGENDADA'}</span>
              </div>
            );
          })}
      </div>

      <div className="pvc-dash-card">
        <div className="pvc-dash-cab"><FileText size={22} color="#2563eb" /><b>Últimos documentos</b><button type="button" className="pvc-dash-link" onClick={() => setAba('todos')}>Ver todos <ChevronRight size={16} /></button></div>
        {docs === null ? <div className="pvc-dash-vazio">Carregando...</div>
          : !docs.length ? <div className="pvc-dash-vazio">Nenhum documento ainda.</div>
          : docs.map(p => {
            const [cor, fundo] = COR_DOC[p.tipo] || ['#7c3aed', '#ede9fe'];
            return (
              <button key={p.id} type="button" className="pvc-doc" onClick={() => abrirMateria(p, setAba)} title={p.ementa}>
                <span className="pvc-doc-ic" style={{ background: fundo }}><FileText size={20} color={cor} /></span>
                <span className="pvc-doc-txt"><b>{nomeMateria(p)}</b><small>{DATA_CURTA(p.criadoEm)}{p.temPrincipal ? ' · PDF' : ''}{p.anexos && p.anexos.length ? ` · ${p.anexos.length} anexo(s)` : ''}</small></span>
                <ChevronRight size={18} color="#334155" />
              </button>
            );
          })}
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
// Como cada vereador votou (PLENARIUM:VOTOS_AO_VIVO)
// Depois que o vereador vota, aparece a grade com a foto de todos e o voto
// de cada um, em tempo real; quando a votacao encerra, a grade fica com o
// resultado ate abrir a proxima votacao. Na votacao secreta so os numeros.
// ---------------------------------------------------------------------
let ultimaVotacaoVV = null; // { id, numero, titulo, secreta, status, votos: {vereadorId: opcao} }
let _vereadoresVV = null;
const ROTULO_VV = { SIM: 'SIM', NAO: 'NÃO', ABSTENCAO: 'ABSTENÇÃO', AUSENTE: 'AUSENTE', AGUARDANDO: 'AGUARDANDO', NAO_VOTOU: 'NÃO VOTOU' }; // PLENARIUM:NAO_VOTOU
const COR_VV = {
  SIM: { fundo: '#dcfce7', borda: '#86efac', txt: '#166534', ic: '#16a34a', card: '#22c55e' },
  NAO: { fundo: '#fee2e2', borda: '#fca5a5', txt: '#991b1b', ic: '#dc2626', card: '#ef4444' },
  ABSTENCAO: { fundo: '#fef3c7', borda: '#fcd34d', txt: '#92400e', ic: '#d97706', card: '#f59e0b' },
  AUSENTE: { fundo: '#f1f5f9', borda: '#e2e8f0', txt: '#64748b', ic: '#94a3b8', card: '#e2e8f0' },
  AGUARDANDO: { fundo: '#f8fafc', borda: '#e2e8f0', txt: '#64748b', ic: '#94a3b8', card: '#e2e8f0' },
  NAO_VOTOU: { fundo: '#f8fafc', borda: '#cbd5e1', txt: '#475569', ic: '#64748b', card: '#e2e8f0' } // PLENARIUM:NAO_VOTOU -- presente, mas nao votou
};
function IconeVV({ tipo, cor }) {
  if (tipo === 'AUSENTE') return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={cor} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="8" r="4" /><path d="M2.5 21v-.5A6.5 6.5 0 0 1 12 15" /><path d="M16 15l5 5M21 15l-5 5" /></svg>;
  if (tipo === 'NAO_VOTOU') return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={cor} strokeWidth="2.4" strokeLinecap="round"><circle cx="12" cy="12" r="9" /><path d="M8 12h8" /></svg>; // PLENARIUM:NAO_VOTOU
  if (tipo === 'AGUARDANDO') return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={cor} strokeWidth="2.4" strokeLinecap="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3.2 2" /></svg>;
  const traco = tipo === 'NAO' ? 'M8 8l8 8M16 8l-8 8' : tipo === 'ABSTENCAO' ? 'M7 12h10' : 'M6.8 12.6l3.4 3.4L17.4 8.6';
  return <svg width="17" height="17" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12" fill={cor} /><path d={traco} fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
const mapaVotosVV = (votos) => { const m = {}; (votos || []).forEach(v => { if (v && v.vereadorId) m[v.vereadorId] = v.opcao; }); return m; };
// PLENARIUM:SEGURANCA -- na secreta o servidor manda so totalVotos (aberta) e o placar sem donos (encerrada)
const placarVV = (votos) => { const c = { SIM: 0, NAO: 0, ABSTENCAO: 0 }; (votos || []).forEach(v => { if (v && c[v.opcao] !== undefined) c[v.opcao]++; }); return c; };
const doPautaVV = (p) => ({ id: p.id, numero: p.numero, titulo: p.titulo, secreta: !!p.votacaoSecreta, status: p.status, votos: mapaVotosVV(p.votos), placar: placarVV(p.votos), total: typeof p.totalVotos === 'number' ? p.totalVotos : (p.votos || []).length });

export function VotosDosVereadores({ pautaAtiva, jaVotou, sessaoId, pautas = [], meuId, meuVoto }) {
  const [vereadores, setVereadores] = useState(_vereadoresVV || []);
  const [presenca, setPresenca] = useState(null);
  const [atual, setAtual] = useState(() => (pautaAtiva ? doPautaVV(pautaAtiva) : ultimaVotacaoVV));
  const idAtiva = pautaAtiva ? pautaAtiva.id : null;
  // a votacao aberta (ou a ultima encerrada, se a pagina foi recarregada)
  useEffect(() => {
    if (pautaAtiva) {
      setAtual(a => {
        const base = doPautaVV(pautaAtiva);
        if (a && a.id === base.id) return { ...base, votos: { ...base.votos, ...a.votos }, total: Math.max(base.total, a.total || 0) };
        return base;
      });
    } else {
      // votacao encerrada: o painel ja atualizou a lista de pautas com o resultado
      const ult = ultimaVotacaoVV;
      const naLista = ult && pautas.find(p => p.id === ult.id);
      if (naLista && naLista.status !== 'EM_VOTACAO') {
        const novo = (naLista.votos || []).length ? doPautaVV(naLista) : { ...ult, status: naLista.status };
        ultimaVotacaoVV = novo; setAtual(novo);
      } else if (ult && ult.status !== 'EM_VOTACAO') setAtual(ult);
      else {
        const fim = [...pautas].filter(p => ['APROVADA', 'REPROVADA'].includes(p.status) && (p.votos || []).length).sort((a, b) => (b.ordem || 0) - (a.ordem || 0))[0];
        if (fim) { ultimaVotacaoVV = doPautaVV(fim); setAtual(ultimaVotacaoVV); }
      }
    }
  }, [idAtiva, pautaAtiva, pautas]);
  useEffect(() => { if (atual) ultimaVotacaoVV = atual; }, [atual]);
  // vereadores (uma vez) e presenca da sessao
  useEffect(() => {
    let vivo = true;
    if (!_vereadoresVV) axios.get('/api/vereadores').then(r => { _vereadoresVV = (Array.isArray(r.data) ? r.data : []).filter(v => v.ativo !== false); if (vivo) setVereadores(_vereadoresVV); }).catch(() => {});
    return () => { vivo = false; };
  }, []);
  const carregarPresenca = useCallback(() => {
    if (!sessaoId) return;
    axios.get(`/api/relatorios/sessao/${sessaoId}`).then(r => setPresenca(r.data?.presenca || [])).catch(() => {});
  }, [sessaoId]);
  useEffect(() => { carregarPresenca(); }, [carregarPresenca]);
  // tempo real: cada voto, o encerramento e a proxima votacao
  useEffect(() => {
    if (!sessaoId) return undefined;
    const s = io(process.env.REACT_APP_API_URL || 'http://localhost:3001');
    s.on('connect', () => s.emit('entrar-sala', `sessao-${sessaoId}`));
    s.on('novo-voto', (d) => {
      setAtual(a => {
        if (!a || !d || d.pautaId !== a.id) return a;
        const votos = d.voto && d.voto.vereadorId ? { ...a.votos, [d.voto.vereadorId]: d.voto.opcao } : a.votos;
        const total = typeof d.totalVotos === 'number' ? d.totalVotos : Array.isArray(d.contagem) ? d.contagem.reduce((t, c) => t + ((c._count && c._count.opcao) || 0), 0) : a.total; // PLENARIUM:SEGURANCA
        return { ...a, votos, total };
      });
    });
    s.on('pauta-encerrada', (p) => {
      setAtual(a => {
        if (!p) return a;
        const fim = doPautaVV(p);
        if (a && a.id === fim.id && !(p.votos || []).length) return { ...a, status: p.status };
        return fim;
      });
    });
    s.on('pauta-iniciada', () => { ultimaVotacaoVV = null; });
    s.on('presenca-atualizada', carregarPresenca);
    return () => s.disconnect();
  }, [sessaoId, carregarPresenca]);

  const mostrar = atual && ((pautaAtiva && jaVotou && atual.id === pautaAtiva.id) || (!pautaAtiva && atual.status !== 'EM_VOTACAO'));
  if (!mostrar || !vereadores.length) return null;
  const aberta = !!pautaAtiva;
  if (aberta && meuId && meuVoto && !atual.votos[meuId]) atual.votos[meuId] = meuVoto; // o proprio voto aparece mesmo antes do aviso do servidor
  const presente = (v) => { if (!presenca || !presenca.length) return true; const p = presenca.find(x => x.id === v.id); return p ? !!p.presente : false; };
  const presentes = vereadores.filter(presente).length;
  const st = atual.status;
  return (
    <div className="pvc-vv">
      <div className="pvc-vv-cab">
        <div style={{ minWidth: 0 }}>
          <div className="pvc-vv-tit">Como cada vereador votou</div>
          <div className="pvc-vv-sub">{atual.numero}{atual.titulo ? ` · ${atual.titulo}` : ''}</div>
        </div>
        {aberta
          ? <span className="pvc-vv-selo vivo"><span className="pvc-vv-ponto" />AO VIVO</span>
          : <span className={`pvc-vv-selo ${st === 'APROVADA' ? 'ok' : st === 'REPROVADA' ? 'nao' : ''}`}>{st === 'APROVADA' ? 'APROVADA' : st === 'REPROVADA' ? 'REPROVADA' : st === 'RETIRADA' ? 'RETIRADA' : 'ENCERRADA'}</span>}
      </div>
      {atual.secreta ? (
        <div className="pvc-vv-secreta">Votação secreta: os votos não são mostrados por vereador. {aberta || st === 'EM_VOTACAO'
          ? <>{atual.total || 0} de {presentes} presente(s) já votaram. O placar aparece ao encerrar.</>
          : <>Resultado: <b style={{ color: '#15803d' }}>SIM {(atual.placar || {}).SIM || 0}</b> · <b style={{ color: '#b91c1c' }}>NÃO {(atual.placar || {}).NAO || 0}</b> · <b style={{ color: '#92400e' }}>ABST. {(atual.placar || {}).ABSTENCAO || 0}</b></>}</div>
      ) : (
        <>
          <div className="pvc-vv-grade">
            {vereadores.map(v => {
              const op = atual.votos[v.id];
              const tipo = op || (presente(v) ? (aberta ? 'AGUARDANDO' : 'NAO_VOTOU') : 'AUSENTE'); // PLENARIUM:NAO_VOTOU -- presente sem voto nao e ausente
              const c = COR_VV[tipo] || COR_VV.AGUARDANDO;
              const foto = v.fotoUrl;
              return (
                <div key={v.id} className={`pvc-vv-card ${op ? 'votou' : ''}`} style={{ borderColor: op ? c.card : undefined, opacity: tipo === 'AUSENTE' ? 0.6 : 1 }}>
                  <div className="pvc-vv-foto">{foto ? <img src={foto} alt="" /> : <span>{iniciais(nomeV(v))}</span>}</div>
                  <div className="pvc-vv-info">
                    <b title={nomeV(v)}>{exibCurtoV(v)}</b>
                    <small>{v.partido || ' '}</small>
                    <span className="pvc-vv-voto" style={{ background: c.fundo, borderColor: c.borda, color: c.txt }}><IconeVV tipo={tipo} cor={c.ic} /><span>{ROTULO_VV[tipo]}</span></span>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
      {!aberta && <div className="pvc-vv-rodape">Fica na tela até a próxima votação ser aberta.</div>}
    </div>
  );
}

function saudacao() { const h = new Date().getHours(); return h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite'; }
function tratamentoDe(u) { if (!u) return 'Vereador'; if (u.cargo === 'PRESIDENTE') return 'Presidente'; return u.sexo === 'F' ? 'Vereadora' : 'Vereador'; }

function Foto({ url, nome, w = 40, h = 50, raio = 8 }) {
  return (
    <span style={{ width: w, height: h, flexShrink: 0, borderRadius: raio, overflow: 'hidden', background: '#e2e8f0', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#64748b', fontWeight: 800, fontSize: Math.round(w / 2.6) }}>
      {url ? <img src={url} alt={nome} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }} /> : iniciais(nome)}
    </span>
  );
}

// Fotos dos vereadores, buscadas uma vez so (a mesma lista que o painel usa).
let _fotosPromessa = null;
function useFotos() {
  const [fotos, setFotos] = useState({});
  useEffect(() => {
    let vivo = true;
    if (!_fotosPromessa) _fotosPromessa = axios.get('/api/vereadores').then(r => { const m = {}; (Array.isArray(r.data) ? r.data : []).forEach(v => { m[v.id] = v.fotoUrl || ''; }); return m; }).catch(() => { _fotosPromessa = null; return {}; });
    _fotosPromessa.then(m => { if (vivo) setFotos(m); });
    return () => { vivo = false; };
  }, []);
  return fotos;
}

// ---------------------------------------------------------------------
// Nome da camara em duas linhas: "CAMARA MUNICIPAL DE" + "GUAJARA".
function partesCamara(nome) {
  const n = String(nome || 'Câmara Municipal').trim();
  const m = n.match(/^(c[âa]mara\s+municipal(?:\s+d[eoa]s?)?)\s+(.+)$/i);
  return m ? [m[1], m[2]] : ['', n];
}

// Cabecalho azul (brasao + nome da camara + vereador). Em todas as telas
// dos cards; o cabecalho antigo some (o Presidente mantem a faixa da sessao).
export function TopoCamara({ usuario, isPresidente, comFoto, itens = [], onInicio, avisos: avisosTela, children, setAba }) {
  if (avisosTela) avisosGuardados = avisosTela;
  const avisos = avisosTela || avisosGuardados;
  const fotos = useFotos();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [menu, setMenu] = useState(false);
  const [sino, setSino] = useState(false);
  const refMenu = useRef(null);
  const foto = (usuario && fotos[usuario.id]) || usuario?.fotoUrl || '';
  const [prefixo, cidade] = partesCamara(usuario?.camara?.nome);
  useEffect(() => {
    const c = document.body.classList;
    c.add('pvc-topo-on'); if (isPresidente) c.add('pvc-topo-pres');
    return () => { c.remove('pvc-topo-on'); c.remove('pvc-topo-pres'); };
  }, [isPresidente]);
  useAlturaCabecalho(); // depois da classe acima: mede ja com o cabecalho antigo escondido
  useEffect(() => {
    if (!menu && !sino) return undefined;
    const fora = (e) => { if (refMenu.current && !refMenu.current.contains(e.target)) { setMenu(false); setSino(false); } };
    document.addEventListener('pointerdown', fora);
    return () => document.removeEventListener('pointerdown', fora);
  }, [menu, sino]);
  const sair = () => { // o mesmo do painel: volta ao login da camara
    const slug = usuario?.camara?.slug;
    logout();
    navigate(slug ? `/camara/${slug}/login/vereador` : '/login/vereador');
  };
  const todos = [
    ...(onInicio ? [['inicio', <ChevronDown size={17} style={{ transform: 'rotate(90deg)' }} />, 'Início', onInicio]] : []),
    ...itens,
    ['atualizar', <RefreshCw size={17} />, 'Atualizar', () => window.location.reload()],
    ['sair', <LogOut size={17} />, 'Sair', sair, '#dc2626']
  ];
  return (
    <header className={`pvc-topo ${comFoto ? '' : 'pvc-topo-comp'} ${children ? 'pvc-topo-hero' : ''}`}>
      <div className="pvc-topo-linha">
      <div className="pvc-topo-camara">
        <span className="pvc-pc-marca pvc-so-pc"><img src="/logo512.png" alt="" /><span><b>PLENARIUM</b><small>DIGITAL</small></span></span>
        <span className="pvc-topo-div pvc-so-pc" />
        <span className="pvc-topo-brasao">
          {usuario?.camara?.logoUrl ? <img src={usuario.camara.logoUrl} alt="Brasão" /> : <span style={{ fontSize: 34 }}>🏛️</span>}
        </span>
        <span className="pvc-topo-div" />
        <span style={{ minWidth: 0 }}>
          {prefixo && <span className="pvc-topo-pre">{prefixo}</span>}
          <span className="pvc-topo-cidade">{cidade}</span>
        </span>
      </div>
      {setAba && <BuscaSistema setAba={setAba} />}
      <div className="pvc-topo-perfil" ref={refMenu}>
        {avisos && (
          <button type="button" className="pvc-sino" onClick={() => { setSino(v => !v); setMenu(false); }} aria-label="Avisos">
            <Bell size={24} color="#fff" />{avisos.length > 0 && <span className="pvc-sino-num">{avisos.length}</span>}
          </button>
        )}
        {sino && (
          <div className="pvc-menu pvc-avisos">
            <div className="pvc-menu-nome"><b>Avisos</b></div>
            {!avisos.length ? <div style={{ padding: '10px 12px 14px', color: '#64748b' }}>Nenhum aviso no momento.</div>
              : avisos.map((a, i) => (
                <button key={i} type="button" className="pvc-menu-item" style={{ alignItems: 'flex-start' }} onClick={() => { setSino(false); a.acao(); }}>
                  <span className="pvc-aviso-ponto" style={{ background: a.cor || '#2563eb' }} />
                  <span style={{ minWidth: 0 }}><span style={{ display: 'block' }}>{a.titulo}</span><small style={{ color: '#64748b', fontWeight: 500 }}>{a.sub}</small></span>
                </button>
              ))}
          </div>
        )}
        {comFoto ? <span className="pvc-topo-div" /> : avisos && <span className="pvc-topo-div pvc-so-pc" />}
        <button type="button" className="pvc-topo-foto" onClick={() => setMenu(m => !m)} aria-label="Menu do vereador">
          {comFoto
            ? <span className="pvc-topo-circ">{foto ? <img src={foto} alt={nomeV(usuario)} /> : iniciais(nomeV(usuario))}</span>
            : <><span className="pvc-topo-circ pvc-so-pc">{foto ? <img src={foto} alt={nomeV(usuario)} /> : iniciais(nomeV(usuario))}</span><span className="pvc-topo-quem pvc-nao-pc"><b>{exibCurtoV(usuario)}</b><small>{usuario?.partido || tratamentoDe(usuario)}</small></span></>}
          <ChevronDown size={22} color="#fff" style={{ transition: 'transform .15s', transform: menu ? 'rotate(180deg)' : 'none', flexShrink: 0 }} />
        </button>
        {menu && !sino && (
          <div className="pvc-menu">
            <div className="pvc-menu-nome"><b>{nomeV(usuario)}</b><small>{tratamentoDe(usuario)}{usuario?.partido ? ` · ${usuario.partido}` : ''}</small></div>
            {todos.map(([k, ic, txt, acao, cor]) => (
              <button key={k} type="button" className="pvc-menu-item" style={cor ? { color: cor } : undefined} onClick={() => { setMenu(false); acao(); }}>{ic}{txt}</button>
            ))}
            <EscolhaTema />
            <div className="pvc-menu-marca">Plenarium Digital</div>
          </div>
        )}
      </div>
      </div>
      {children && <div className="pvc-topo-extra">{children}</div>}
      {children && (
        <svg className="pvc-onda" viewBox="0 0 1440 60" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0,34 C240,62 480,6 720,26 C960,46 1200,58 1440,22 L1440,60 L0,60 Z" fill="rgba(255,255,255,.18)" />
          <path d="M0,44 C260,64 520,18 760,36 C1000,54 1220,56 1440,34 L1440,60 L0,60 Z" fill="#f1f5f9" />
        </svg>
      )}
    </header>
  );
}

export function InicioCards({ usuario, sessao, pautaAtiva, jaVotou, isPresidente, setAba, onSenha, onFoto, onLogout, modoClaro, setModoClaro, leituras = false, comissoes = false }) {
  const ic = 30;
  const ehPC = useEhPC();
  // Avisos do sino: votacao esperando o voto e faltas a justificar.
  const [faltas, setFaltas] = useState([]);
  const idSessao = sessao ? sessao.id : null;
  useEffect(() => {
    let vivo = true;
    axios.get('/api/justificativas/minhas').then(r => { if (vivo) setFaltas(Array.isArray(r.data) ? r.data : []); }).catch(() => {});
    return () => { vivo = false; };
  }, [idSessao]);
  // PLENARIUM:ATA_RETIFICACAO -- ata anterior aberta para pedidos e respostas da Mesa
  const [infoAta, setInfoAta] = useState(null);
  useEffect(() => {
    let vivo = true;
    axios.get('/api/atas/minhas').then(r => { if (vivo) setInfoAta(r.data || null); }).catch(() => {});
    return () => { vivo = false; };
  }, [idSessao]);
  const ataAberta = !!(infoAta && (infoAta.atas || []).some(a => a.aberta));
  const respAta = (infoAta && infoAta.respostasRecentes) || 0;
  // PLENARIUM:TRIBUNA -- inscricoes abertas / minha vez, em tempo real
  const [listasTrib] = useTribuna(sessao && sessao.status === 'EM_ANDAMENTO' ? sessao.id : null);
  const rTrib = resumoTribuna(listasTrib, usuario && usuario.id);
  const semJust = faltas.filter(x => !x.justificativa).length;
  const recusadas = faltas.filter(x => x.justificativa && x.justificativa.status === 'RECUSADA').length;
  const avisos = [
    ...(pautaAtiva && !jaVotou ? [{ titulo: `Votação aberta: ${pautaAtiva.numero}`, sub: 'Toque para votar', cor: '#dc2626', acao: () => setAba('votacao') }] : []),
    ...(semJust ? [{ titulo: `${semJust} falta(s) sem justificativa`, sub: 'Justifique em Presenças', cor: '#c2410c', acao: () => setAba('presencas') }] : []),
    ...(recusadas ? [{ titulo: `${recusadas} justificativa(s) recusada(s)`, sub: 'Veja o motivo em Presenças', cor: '#b91c1c', acao: () => setAba('presencas') }] : []),
    ...(sessao && rTrib.aberta ? [{ titulo: `Tribuna: inscrições abertas`, sub: `${rTrib.aberta.fase} · toque para se inscrever`, cor: '#4338ca', acao: () => setAba('tribuna') }] : []), // PLENARIUM:TRIBUNA
    ...(respAta ? [{ titulo: `${respAta} resposta(s) da Mesa à retificação da ata`, sub: 'Veja em Ata Anterior', cor: '#b45309', acao: () => setAba('ata') }] : []) // PLENARIUM:ATA_RETIFICACAO
  ];
  const cards = [
    {
      id: 'votacao', icone: <Vote size={ic} color="#dc2626" />, fundo: '#fee2e2', titulo: 'Votação',
      sub: pautaAtiva ? (jaVotou ? `${pautaAtiva.numero} · voto registrado` : `${pautaAtiva.numero} aguardando seu voto`) : sessao ? 'Votação e Ordem do Dia' : 'Sem sessão no momento',
      agora: !!pautaAtiva && !jaVotou
    },
    // PLENARIUM:LEITURAS -- so para o 1o e o 2o Secretario
    // PLENARIUM:COMISSOES -- so para quem integra comissao ou e relator
    ...(comissoes ? [{ id: 'comissoes', icone: <Users size={ic} color="#15803d" />, fundo: '#dcfce7', titulo: 'Comissões', sub: comissoes.pendentes ? `${comissoes.pendentes} pendência(s): parecer ou voto` : 'Relatorias e pareceres', agora: !!comissoes.pendentes }] : []),
    ...(leituras ? [{ id: 'leituras', icone: <ScrollText size={ic} color="#3730a3" />, fundo: '#e0e7ff', titulo: 'Leituras da Mesa', sub: sessao ? 'Ata anterior, Expediente e Ordem do Dia' : 'Sem sessão no momento', agora: !!sessao && !pautaAtiva }] : []),
    { id: 'tribuna', icone: <Mic size={ic} color="#4338ca" />, fundo: '#e0e7ff', titulo: 'Tribuna', sub: sessao ? rTrib.sub : 'Sem sessão no momento', agora: !!sessao && rTrib.agora }, // PLENARIUM:TRIBUNA
    { id: 'ata', icone: <BookOpen size={ic} color="#b45309" />, fundo: '#fef3c7', titulo: 'Ata Anterior', sub: ataAberta ? 'Leia e peça retificação até a votação' : 'Ata da sessão anterior' }, // PLENARIUM:ATA_RETIFICACAO
    { id: 'presencas', icone: <Users size={ic} color="#0891b2" />, fundo: '#cffafe', titulo: 'Presenças', sub: semJust ? `Presença de cada sessão · ${semJust} falta(s) a justificar` : 'Presença de cada sessão' },
    { id: 'historico', icone: <History size={ic} color="#7c3aed" />, fundo: '#ede9fe', titulo: 'Sessões', sub: 'Matérias, votações e eleição da Mesa' },
    { id: 'projetos', icone: <FileText size={ic} color="#15803d" />, fundo: '#dcfce7', titulo: 'Meus Projetos', sub: 'De sua autoria' },
    { id: 'todos', icone: <ClipboardList size={ic} color="#b45309" />, fundo: '#fef3c7', titulo: 'Todos os Projetos', sub: 'Matérias da Câmara e documentos' },
    { id: 'documentos', icone: <FileText size={ic} color="#0f766e" />, fundo: '#ccfbf1', titulo: 'Central de Documentos', sub: 'Requerimentos, pareceres, indicações...' }, // PLENARIUM:CENTRAL_DOCUMENTOS
    { id: 'requerimento', icone: <Plus size={ic} color="#475569" />, fundo: '#f1f5f9', titulo: 'Novo Requerimento', sub: 'Enviar à Mesa' }
  ];
  return (
    <div className="pvc-inicio-tela">
      <TopoCamara usuario={usuario} isPresidente={isPresidente} comFoto avisos={avisos} setAba={setAba} itens={[
        ['senha', <KeyRound size={17} />, 'Alterar senha', onSenha],
        ['foto', <Camera size={17} />, 'Minha foto', onFoto]
      ]}>
        <div className="pvc-ola">{saudacao()},</div>
        <div className="pvc-ola-nome">{tratamentoDe(usuario)} {nomeV(usuario)}</div>
        {sessao
          ? <button type="button" className="pvc-ola-sessao" onClick={() => setAba('votacao')}><span className="pvc-ponto" /><span className="pvc-ola-sessao-txt">Sessão em andamento — {sessao.titulo}</span><ChevronDown size={16} style={{ transform: 'rotate(-90deg)', flexShrink: 0 }} /></button>
          : <p className="pvc-ola-sub">Escolha o que deseja acessar.</p>}
      </TopoCamara>

      <AbasNav aba="inicio" setAba={setAba} votacaoAberta={!!pautaAtiva} leituras={leituras} comissoes={!!comissoes} />
      <div className="pvc-inicio-corpo">
        {ehPC && <PainelInicioPC usuario={usuario} sessao={sessao} setAba={setAba} />}
        <div className="pvc-grade">
          {cards.map(c => (
            <button key={c.id} type="button" className={`pvc-card ${c.agora ? 'pvc-agora' : ''}`} onClick={() => setAba(c.id)}>
              {c.agora && <span className="pvc-selo">AGORA</span>}
              <span className="pvc-ic" style={{ background: c.fundo }}>{c.icone}</span>
              <span className="pvc-card-txt"><b>{c.titulo}</b><span className="pvc-sub">{c.sub}</span></span>
              <ChevronDown size={22} color="#334155" style={{ transform: 'rotate(-90deg)', flexShrink: 0 }} />
            </button>
          ))}
        </div>
        <div className="pvc-assinatura">Plenarium Digital · desenvolvido por iSolutions</div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
// Abas (no lugar do "← Inicio"): aparecem em todas as telas, menos no Inicio.
const ABAS = [
  ['inicio', 'Início', (c) => <Home size={18} color={c} />, '#2563eb', '#e0edff'],
  ['votacao', 'Votação', (c) => <Vote size={18} color={c} />, '#dc2626', '#fee2e2'],
  ['presencas', 'Presenças', (c) => <Users size={18} color={c} />, '#0891b2', '#cffafe'],
  ['historico', 'Sessões|Sessões', (c) => <History size={18} color={c} />, '#7c3aed', '#ede9fe'],
  ['projetos', 'Meus Projetos|Meus Projetos', (c) => <FileText size={18} color={c} />, '#15803d', '#dcfce7'],
  ['todos', 'Todos os Projetos|Todos Projetos', (c) => <ClipboardList size={18} color={c} />, '#b45309', '#fef3c7'],
  ['documentos', 'Central de Documentos|Documentos', (c) => <FileText size={18} color={c} />, '#0f766e', '#ccfbf1'], // PLENARIUM:CENTRAL_DOCUMENTOS
  ['requerimento', 'Novo Requerimento|Requerimento', (c) => <Plus size={18} color={c} />, '#475569', '#f1f5f9']
];
// PLENARIUM:LEITURAS -- a aba "Leituras" so aparece para o 1o e o 2o Secretario
const ABA_LEITURAS = ['leituras', 'Leituras da Mesa|Leituras', (c) => <ScrollText size={18} color={c} />, '#3730a3', '#e0e7ff'];
// PLENARIUM:COMISSOES -- a aba "Comissoes" so aparece para quem integra comissao
const ABA_COMISSOES = ['comissoes', 'Comissões|Comissões', (c) => <Users size={18} color={c} />, '#15803d', '#dcfce7'];
// PLENARIUM:ATA_RETIFICACAO -- a aba "Ata Anterior" aparece para todos os vereadores
const ABA_ATA = ['ata', 'Ata Anterior|Ata', (c) => <BookOpen size={18} color={c} />, '#b45309', '#fef3c7'];
// PLENARIUM:TRIBUNA -- a aba "Tribuna" aparece para todos, logo depois da Votacao
const ABA_TRIBUNA = ['tribuna', 'Tribuna|Tribuna', (c) => <Mic size={18} color={c} />, '#4338ca', '#e0e7ff'];
const abasDe = (leituras, comissoes) => [ABAS[0], ABAS[1], ABA_TRIBUNA, ...(leituras ? [ABA_LEITURAS] : []), ...(comissoes ? [ABA_COMISSOES] : []), ABA_ATA, ...ABAS.slice(2)];
// Toque na aba atual: volta para o comeco dela (ex.: de dentro de uma sessao para a lista).
function irPara(id, aba, setAba) {
  const ativa = aba === 'controle' ? 'votacao' : aba;
  if (id === ativa) { try { window.dispatchEvent(new Event('pvc:aba-de-novo')); } catch (e) { /* segue */ } return; }
  setAba(id);
}
const NO_RODAPE = ['inicio', 'votacao', 'presencas', 'historico'];

// Tablets e celulares: barra fixa no rodape, como em aplicativo (4 telas + "Mais").
function RodapeNav({ aba, setAba, votacaoAberta, leituras = false, comissoes = false }) {
  const [mais, setMais] = useState(false);
  const ativa = aba === 'controle' ? 'votacao' : aba;
  const ABAS_V = abasDe(leituras, comissoes); // PLENARIUM:LEITURAS + COMISSOES
  const extras = ABAS_V.filter(([id]) => !NO_RODAPE.includes(id));
  const maisAtivo = extras.some(([id]) => id === ativa);
  const ir = (id) => { setMais(false); irPara(id, aba, setAba); };
  useEffect(() => {
    const c = document.body.classList; c.add('pvc-com-rodape');
    return () => c.remove('pvc-com-rodape');
  }, []);
  return (
    <>
      {mais && (
        <div className="pvc-mais-fundo" onClick={() => setMais(false)}>
          <div className="pvc-mais" onClick={(e) => e.stopPropagation()}>
            <div className="pvc-mais-alca" />
            {extras.map(([id, rot, ic, cor, fundo]) => (
              <button key={id} type="button" className={`pvc-mais-item ${ativa === id ? 'ativa' : ''}`} onClick={() => ir(id)}>
                <span className="pvc-aba-ic" style={{ background: fundo }}>{ic(cor)}</span>{rot.split('|')[0]}
                <ChevronDown size={20} color="#94a3b8" style={{ transform: 'rotate(-90deg)', marginLeft: 'auto' }} />
              </button>
            ))}
            <button type="button" className="pvc-mais-item" onClick={() => window.location.reload()}>
              <span className="pvc-aba-ic" style={{ background: '#f1f5f9' }}><RefreshCw size={18} color="#475569" /></span>Atualizar
            </button>
          </div>
        </div>
      )}
      <nav className="pvc-rodape" aria-label="Menu do painel">
        {ABAS_V.filter(([id]) => NO_RODAPE.includes(id)).map(([id, rot, ic]) => (
          <button key={id} type="button" className={`pvc-rod ${ativa === id && !mais ? 'ativa' : ''}`} onClick={() => ir(id)}>
            <span className="pvc-rod-ic">{ic(ativa === id && !mais ? '#1d4ed8' : '#64748b')}{id === 'votacao' && votacaoAberta && <span className="pvc-aba-ponto" />}</span>
            <span>{rot.split('|').pop()}</span>
          </button>
        ))}
        <button type="button" className={`pvc-rod ${maisAtivo || mais ? 'ativa' : ''}`} onClick={() => setMais(m => !m)}>
          <span className="pvc-rod-ic"><span className="pvc-tres-pontos" style={{ color: maisAtivo || mais ? '#1d4ed8' : '#64748b' }}>•••</span></span>
          <span>Mais</span>
        </button>
      </nav>
    </>
  );
}

function AbasNav({ aba, setAba, votacaoAberta, leituras = false, comissoes = false }) {
  const ref = useRef(null);
  const ativa = aba === 'controle' ? 'votacao' : aba;
  useEffect(() => { // no celular, deixa a aba atual visivel na faixa
    try { const el = ref.current && ref.current.querySelector('.pvc-aba.ativa'); if (el) el.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) { /* segue */ }
  }, [ativa]);
  return (
    <nav className="pvc-abas" ref={ref} aria-label="Menu do painel">
      {abasDe(leituras, comissoes).map(([id, rot, ic, cor, fundo]) => (
        <button key={id} type="button" data-aba={id} className={`pvc-aba ${ativa === id ? 'ativa' : ''} ${id === 'inicio' ? 'pvc-aba-inicio' : ''}`} onClick={() => irPara(id, aba, setAba)}>
          <span className="pvc-aba-ic" style={{ background: fundo }}>{ic(cor)}{id === 'votacao' && votacaoAberta && <span className="pvc-aba-ponto" />}</span>
          <span className="pvc-aba-rot pvc-rot-longo">{rot.split('|')[0]}</span><span className="pvc-aba-rot pvc-rot-curto">{rot.split('|').pop()}</span>
        </button>
      ))}
    </nav>
  );
}

export function BarraSecao({ aba, setAba, isPresidente, sessao, usuario, fotoExibida, onOrdem, pautaAtiva, leituras = false, comissoes = false }) {
  const naVotacao = aba === 'votacao' || aba === 'controle';
  const votacaoAberta = !!pautaAtiva || !!(sessao && (sessao.pautas || []).some(p => p.status === 'EM_VOTACAO'));
  const comFoto = naVotacao && (aba === 'controle' || pautaAtiva);
  return (
    <>
      <TopoCamara usuario={usuario} isPresidente={isPresidente} onInicio={() => setAba('inicio')} setAba={setAba} />
      <AbasNav aba={aba} setAba={setAba} votacaoAberta={votacaoAberta} leituras={leituras} comissoes={!!comissoes} />
      <RodapeNav aba={aba} setAba={setAba} votacaoAberta={votacaoAberta} leituras={leituras} comissoes={!!comissoes} />
      <div className={`pvc-barra ${comFoto || (naVotacao && sessao) || isPresidente ? '' : 'pvc-barra-so-atualizar'}`}>
        {/* Foto: quando nao ha votacao aberta, ela ja aparece no cartao "Bem-vindo(a)";
            entao aqui so aparece durante a votacao (ou nos Controles), sem repetir. */}
        {comFoto ? (
          <div className="pvc-barra-nome" style={{ flex: 1 }}>
            <Foto url={fotoExibida} nome={nomeV(usuario)} w={42} h={52} />
            <span className="pvc-barra-txt" style={{ minWidth: 0 }}>
              <b style={{ display: 'block', fontSize: '1.02rem', color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{tratamentoDe(usuario)} {nomeV(usuario)}</b>
              <small style={{ color: '#64748b', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{usuario?.partido || TITULOS[aba]}</small>
            </span>
          </div>
        ) : <span style={{ flex: 1 }} />}
        {naVotacao && sessao && (
          <button type="button" className="pvc-bt pvc-bt-azul" onClick={onOrdem}><Calendar size={17} /> Ordem do Dia</button>
        )}
        {isPresidente && sessao && aba === 'votacao' && (
          <button type="button" className="pvc-bt pvc-bt-verm" onClick={() => setAba('controle')}><Play size={15} /> Controles</button>
        )}
        {isPresidente && aba === 'controle' && (
          <button type="button" className="pvc-bt" onClick={() => setAba('votacao')}><Vote size={15} /> Ver votação</button>
        )}
        <button type="button" className="pvc-bt" onClick={() => window.location.reload()} title="Atualizar"><RefreshCw size={17} /> Atualizar</button>
      </div>
    </>
  );
}

// Tela da Votacao quando nao ha sessao (no lugar da antiga, mesmos dados).
export function TelaSemSessaoCards({ historico = [], usuario = null, fotoExibida = '' }) {
  const [agora, setAgora] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setAgora(new Date()), 1000); return () => clearInterval(t); }, []);
  const p2 = (n) => String(n).padStart(2, '0');
  const dataExtenso = (() => { const s = agora.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }); return s.charAt(0).toUpperCase() + s.slice(1); })();
  const totalVotacoes = historico.reduce((acc, s) => acc + ((s.pautas && s.pautas.length) || 0), 0);
  return (
    <div className="pvc-ss">
      <div className="pvc-ss-perfil">
        <span className="pvc-ss-foto">{fotoExibida ? <img src={fotoExibida} alt={nomeV(usuario)} /> : iniciais(nomeV(usuario))}</span>
        <div style={{ minWidth: 0 }}>
          <div className="pvc-ss-rot">Bem-vindo(a)</div>
          <div className="pvc-ss-nome">{nomeV(usuario) || 'Vereador'}</div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '8px 0' }}>
            <span className="pvc-pill pvc-pill-azul">{tratamentoDe(usuario)}</span>
            {usuario?.partido && <span className="pvc-pill">{usuario.partido}</span>}
          </div>
          <div className="pvc-ss-desc">Acompanhamento em tempo real das atividades legislativas.</div>
        </div>
      </div>
      <div className="pvc-ss-stats">
        {[
          [<Calendar size={30} color="#1d4ed8" />, '#e0edff', 'Sessões realizadas', historico.length, 'Total registradas'],
          [<Vote size={30} color="#15803d" />, '#dcfce7', 'Votações', totalVotacoes, 'Total de votações']
        ].map(([ic, fundo, rot, val, sub]) => (
          <div key={rot} className="pvc-ss-stat">
            <span className="pvc-ss-stat-ic" style={{ background: fundo }}>{ic}</span>
            <div><div className="pvc-ss-rot" style={{ color: '#475569' }}>{rot}</div><div className="pvc-ss-val">{val}</div><div className="pvc-ss-sub">{sub}</div></div>
          </div>
        ))}
      </div>
      <div className="pvc-ss-sit">
        <div className="pvc-ss-rot" style={{ color: '#475569' }}>Situação da sessão</div>
        <div className="pvc-ss-sit-corpo">
          <span className="pvc-ss-sit-ic"><Calendar size={24} color="#1d4ed8" /></span>
          <div className="pvc-ss-sit-txt">Nenhuma sessão em andamento</div>
          <div className="pvc-ss-relogio">{p2(agora.getHours())} : {p2(agora.getMinutes())} : {p2(agora.getSeconds())}</div>
          <div className="pvc-ss-sub">{dataExtenso}</div>
        </div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
// Sessao aberta e o vereador sem presenca: a tela fica aqui ate confirmar
// (como o cartao azul de hoje, mas sem dar para pular). Se a Mesa marcar a
// presenca dele, a tela some sozinha (confere a cada 8 s).
export function TelaPresenca({ sessaoId, usuario, fotoExibida, onLogout }) {
  useTemaPainel(); // PLENARIUM:TEMA
  const [estado, setEstado] = useState('oculto');
  const [enviando, setEnviando] = useState(false);
  const conferir = useCallback(() => {
    if (!sessaoId) { setEstado('oculto'); return; }
    axios.get(`/api/presencas/minha/${sessaoId}`)
      .then(r => setEstado(r.data?.presente ? 'oculto' : 'aberto'))
      .catch(() => { /* sem resposta: nao trava o painel */ });
  }, [sessaoId]);
  useEffect(() => { conferir(); }, [conferir]);
  useEffect(() => {
    if (estado !== 'aberto') return undefined;
    const t = setInterval(conferir, 8000);
    return () => clearInterval(t);
  }, [estado, conferir]);

  if (estado !== 'aberto') return null;
  const confirmar = async () => {
    setEnviando(true);
    try {
      await axios.post(`/api/presencas/confirmar/${sessaoId}`);
      toast.success('Presença confirmada!');
      setEstado('oculto');
      try { window.dispatchEvent(new Event('plenarium:presenca')); } catch (x) { /* segue */ }
    } catch (e) { toast.error(e?.response?.data?.error || 'Não foi possível confirmar a presença'); }
    finally { setEnviando(false); }
  };
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 2147482000, background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, overflowY: 'auto' }}>
      <div style={{ width: 'min(560px, 100%)', display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'center', textAlign: 'center' }}>
        <Foto url={fotoExibida} nome={nomeV(usuario)} w={110} h={138} raio={16} />
        <div style={{ fontSize: '1.3rem', fontWeight: 800, color: '#0f172a' }}>{tratamentoDe(usuario)} {nomeV(usuario)}</div>
        <div style={{ width: '100%', background: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)', borderRadius: 18, padding: '24px 22px', boxShadow: '0 8px 24px rgba(37,99,235,.3)', display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ color: '#fff', fontWeight: 800, fontSize: '1.4rem' }}>Registre sua presença</div>
          <div style={{ color: 'rgba(255,255,255,.88)' }}>A sessão está aberta. Confirme para constar na lista de presença e acessar o painel.</div>
          <button type="button" disabled={enviando} onClick={confirmar} style={{ background: '#fff', color: '#1d4ed8', border: 'none', borderRadius: 14, padding: 18, fontWeight: 900, fontSize: '1.2rem', cursor: enviando ? 'wait' : 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, opacity: enviando ? 0.7 : 1 }}>
            <CheckCircle size={22} /> {enviando ? 'Confirmando…' : 'CONFIRMAR MINHA PRESENÇA'}
          </button>
        </div>
        <button type="button" onClick={onLogout} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', gap: 6 }}><LogOut size={15} /> Sair</button>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
const ST_PAUTA = { APROVADA: ['Aprovada', '#15803d', '#dcfce7'], REPROVADA: ['Reprovada', '#b91c1c', '#fee2e2'], EM_VOTACAO: ['Em votação', '#dc2626', '#fee2e2'], RETIRADA: ['Retirada', '#6b7280', '#f3f4f6'], PENDENTE: ['Pendente', '#475569', '#f1f5f9'] };
const ANEXO = { PROJETO: 'Projeto', PARECER_COMISSAO: 'Parecer de Comissão', PARECER_RELATOR: 'Parecer do Relator', EMENDA: 'Emenda', SUBSTITUTIVO: 'Substitutivo', REDACAO_FINAL: 'Redação Final', OFICIO: 'Ofício', OUTROS: 'Documento' };

function DocumentosDaMateria({ projetoId }) {
  const [docs, setDocs] = useState(null);
  useEffect(() => {
    let vivo = true;
    axios.get(`/api/projetos-camara/${projetoId}/documentos`).then(r => { if (vivo) setDocs(r.data); }).catch(() => { if (vivo) setDocs({ erro: true }); });
    return () => { vivo = false; };
  }, [projetoId]);
  if (!docs) return <div style={{ color: '#64748b', padding: 6 }}>Carregando documentos…</div>;
  if (docs.erro) return <div style={{ color: '#b91c1c', padding: 6 }}>Não foi possível carregar os documentos.</div>;
  const lista = [];
  if (docs.temPrincipal) lista.push({ k: 'p', titulo: 'Texto da matéria', sub: 'Arquivo principal', url: `/api/projetos-camara/${projetoId}/principal` });
  (docs.anexos || []).forEach(a => lista.push({ k: a.id, titulo: ANEXO[a.tipo] || 'Documento', sub: a.nome, url: `/api/projetos-camara/anexo/${a.id}` }));
  if (!lista.length) return <div style={{ color: '#64748b', padding: 6 }}>Nenhum documento anexado.</div>;
  return lista.map(d => (
    <button key={d.k} type="button" onClick={() => abrirDocumento(d.url)} style={{ display: 'flex', alignItems: 'center', gap: 10, textAlign: 'left', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '10px 12px', cursor: 'pointer', fontFamily: 'inherit', color: '#0f172a', width: '100%' }}>
      <FileText size={18} color="#2563eb" /><span style={{ flex: 1, minWidth: 0 }}><b>{d.titulo}</b><br /><small style={{ color: '#64748b' }}>{d.sub}</small></span>
      <span style={{ background: '#2563eb', color: '#fff', fontWeight: 800, fontSize: '.85rem', padding: '6px 12px', borderRadius: 8 }}>Abrir</span>
    </button>
  ));
}

// Ordem do Dia por cima da Votacao (a votacao continua por baixo, em tempo real).
export function GavetaOrdem({ aberto, onFechar, pautas = [] }) {
  const [exp, setExp] = useState(null);
  if (!aberto) return null;
  const lista = [...pautas].sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, zIndex: 2147480000, background: 'rgba(15,23,42,.5)', display: 'flex', justifyContent: 'flex-end' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 'min(640px, 100%)', height: '100%', background: '#f8fafc', display: 'flex', flexDirection: 'column', boxShadow: '-10px 0 30px rgba(0,0,0,.25)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px', background: '#fff', borderBottom: '1px solid #e2e8f0' }}>
          <Calendar size={20} color="#2563eb" /><b style={{ flex: 1, fontSize: '1.15rem' }}>Ordem do Dia</b>
          <button type="button" onClick={onFechar} style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 14px', fontWeight: 800, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontFamily: 'inherit' }}><X size={16} /> Voltar à votação</button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
          {!lista.length && <div style={{ color: '#64748b', textAlign: 'center', padding: 30 }}>Nenhuma matéria nesta sessão.</div>}
          {lista.map((p, i) => {
            const st = ST_PAUTA[p.status] || [p.status, '#475569', '#f1f5f9'];
            const pid = p.projetoId || (p.projeto && p.projeto.id);
            const aberta = exp === p.id;
            return (
              <div key={p.id} style={{ background: '#fff', border: `1px solid ${p.status === 'EM_VOTACAO' ? '#fca5a5' : '#e2e8f0'}`, borderRadius: 12, overflow: 'hidden' }}>
                <button type="button" disabled={!pid} onClick={() => setExp(aberta ? null : p.id)} style={{ width: '100%', textAlign: 'left', background: 'none', border: 'none', padding: '12px 14px', cursor: pid ? 'pointer' : 'default', fontFamily: 'inherit', color: '#0f172a', display: 'flex', gap: 10 }}>
                  <span style={{ color: '#94a3b8', fontWeight: 800 }}>{i + 1}.</span>
                  <span style={{ flex: 1, minWidth: 0 }}>
                    <span style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                      <b>{p.numero}</b>
                      <span style={{ background: st[2], color: st[1], fontWeight: 800, fontSize: '.72rem', padding: '3px 8px', borderRadius: 999 }}>{st[0]}</span>
                    </span>
                    <span style={{ display: 'block', color: '#334155', marginTop: 4, lineHeight: 1.4 }}>{p.titulo}</span>
                    {pid && <small style={{ color: '#2563eb', fontWeight: 700 }}>{aberta ? 'Ocultar documentos' : 'Ver documentos'}</small>}
                  </span>
                  {pid && (aberta ? <ChevronUp size={18} color="#64748b" /> : <ChevronDown size={18} color="#64748b" />)}
                </button>
                {aberta && pid && <div style={{ borderTop: '1px solid #e2e8f0', padding: 10, display: 'flex', flexDirection: 'column', gap: 8, background: '#f8fafc' }}><DocumentosDaMateria projetoId={pid} /></div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
// Presencas da sessao, em tempo real (aviso 'presenca-atualizada').
// Sub-tela (abrir uma sessao) que tambem responde ao "voltar" do aparelho.
function useSubTela() {
  const [sub, setSub] = useState(null);
  useEffect(() => {
    const aoVoltar = (ev) => setSub((ev.state && ev.state.pvcSub) || null);
    window.addEventListener('popstate', aoVoltar);
    // tocar de novo na aba atual (em cima ou no rodape) volta para a lista
    const aoTocarAba = () => { if (window.history.state && window.history.state.pvcSub) window.history.back(); else setSub(null); };
    window.addEventListener('pvc:aba-de-novo', aoTocarAba);
    return () => { window.removeEventListener('popstate', aoVoltar); window.removeEventListener('pvc:aba-de-novo', aoTocarAba); };
  }, []);
  const abrir = (id) => {
    try { window.history.pushState({ ...(window.history.state || {}), pvcSub: id }, ''); } catch (e) { /* segue */ }
    setSub(id);
  };
  const fechar = () => {
    if (window.history.state && window.history.state.pvcSub) window.history.back();
    else setSub(null);
  };
  return [sub, abrir, fechar];
}
const MES_CURTO = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
// Datas da sessao em UTC (e assim que sao cadastradas; igual ao painel).
const diaUTC = (d) => new Date(d).getUTCDate();
const mesUTC = (d) => MES_CURTO[new Date(d).getUTCMonth()];
const dataHoraUTC = (d) => { if (!d) return ''; const x = new Date(d); const p = (n) => String(n).padStart(2, '0'); return `${p(x.getUTCDate())}/${p(x.getUTCMonth() + 1)}/${x.getUTCFullYear()} às ${p(x.getUTCHours())}:${p(x.getUTCMinutes())}`; };
function LinhaSessao({ s, info, direita, onClick }) {
  const viva = s.status === 'EM_ANDAMENTO';
  return (
    <button type="button" className={`pvc-sessao-linha ${viva ? 'pvc-viva' : ''}`} onClick={onClick}>
      <span className="pvc-sessao-data"><b>{diaUTC(s.data)}</b><small>{mesUTC(s.data)}</small></span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span className="pvc-sessao-tit">{s.titulo}</span>
        <span className="pvc-sessao-info">{info}</span>
      </span>
      {direita}
      <ChevronDown size={22} color="#334155" style={{ transform: 'rotate(-90deg)', flexShrink: 0 }} />
    </button>
  );
}
function useTopoAoAbrir(chave) { // volta ao topo da tela ao entrar/sair de uma sessao
  const ref = useRef(null);
  useEffect(() => { try { ref.current && ref.current.scrollIntoView({ block: 'start' }); } catch (e) { /* segue */ } }, [chave]);
  return ref;
}

// Presencas organizadas por SESSAO. A sessao em andamento vem primeiro e
// atualiza em tempo real; as encerradas mostram a presenca de cada uma.
// Usa so rotas que ja existem: /api/sessoes e /api/relatorios/sessao/:id.
const ST_SESSAO = { EM_ANDAMENTO: ['Em andamento', '#b91c1c', '#fee2e2'], ENCERRADA: ['Encerrada', '#475569', '#f1f5f9'], SUSPENSA: ['Suspensa', '#92400e', '#fef3c7'] };
const dataBR = (d) => { try { return new Date(d).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }); } catch { return ''; } };
const diaSemana = (d) => { try { const s = new Date(d).toLocaleDateString('pt-BR', { weekday: 'long' }); return s.charAt(0).toUpperCase() + s.slice(1); } catch { return ''; } };

function CartaoVereadorPresenca({ v }) {
  return (
    <div style={{ background: '#fff', borderRadius: 12, overflow: 'hidden', border: `2px solid ${v.presente ? '#22c55e' : v.faltaJustificada ? '#fdba74' : '#e2e8f0'}`, textAlign: 'center' }}>
      <div style={{ aspectRatio: '3 / 4', background: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b', fontWeight: 800, fontSize: 28 }}>
        {v.fotoUrl ? <img src={v.fotoUrl} alt={nomeV(v)} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top', filter: v.presente ? 'none' : 'grayscale(1)', opacity: v.presente ? 1 : 0.6 }} /> : iniciais(nomeV(v))}
      </div>
      <div style={{ padding: '6px 6px 8px' }}>
        <b style={{ display: 'block', fontSize: '.88rem', color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{nomeV(v)}</b>
        <small style={{ fontWeight: 800, color: v.presente ? '#15803d' : v.faltaJustificada ? '#c2410c' : '#94a3b8' }}>{v.presente ? 'PRESENTE' : v.faltaJustificada ? 'FALTA JUSTIFICADA' : 'AUSENTE'}</small>
      </div>
    </div>
  );
}

function DetalhePresenca({ sessao, minhaFalta, onMudou }) {
  const [lista, setLista] = useState(null);
  const aoVivo = sessao.status === 'EM_ANDAMENTO';
  const carregar = useCallback(async () => {
    try { const r = await axios.get(`/api/relatorios/sessao/${sessao.id}`); setLista(r.data?.presenca || []); } catch { setLista(l => l || []); }
  }, [sessao.id]);
  useEffect(() => {
    setLista(null); carregar();
    if (!aoVivo) return undefined;
    const s = io(process.env.REACT_APP_API_URL || 'http://localhost:3001');
    let primeira = true;
    s.on('connect', () => { s.emit('entrar-sala', `sessao-${sessao.id}`); if (!primeira) carregar(); primeira = false; });
    s.on('presenca-atualizada', carregar);
    s.on('novo-voto', carregar);
    return () => s.disconnect();
  }, [sessao.id, aoVivo, carregar]);
  const st = ST_SESSAO[sessao.status] || [sessao.status, '#475569', '#f1f5f9'];
  const presentes = (lista || []).filter(v => v.presente);
  const ausentes = (lista || []).filter(v => !v.presente);
  const total = (lista || []).length;
  const pct = total ? Math.round((presentes.length / total) * 100) : 0;
  const grade = { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(118px, 1fr))', gap: 10 };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, minWidth: 0 }}>
      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 14, padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <b style={{ fontSize: '1.15rem', color: '#0f172a' }}>{sessao.titulo}</b>
              <span style={{ background: st[2], color: st[1], fontWeight: 800, fontSize: '.72rem', padding: '3px 9px', borderRadius: 999 }}>{aoVivo ? '● AO VIVO' : st[0]}</span>
            </div>
            <div style={{ color: '#64748b', fontSize: '.88rem', marginTop: 2 }}>{diaSemana(sessao.data)}, {dataBR(sessao.data)}</div>
          </div>
        </div>
        {lista && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 8 }}>
            <div style={{ background: '#dcfce7', borderRadius: 10, padding: '8px 10px', textAlign: 'center' }}><div style={{ fontSize: '1.5rem', fontWeight: 900, color: '#15803d' }}>{presentes.length}</div><small style={{ color: '#15803d', fontWeight: 700 }}>Presentes</small></div>
            <div style={{ background: '#f1f5f9', borderRadius: 10, padding: '8px 10px', textAlign: 'center' }}><div style={{ fontSize: '1.5rem', fontWeight: 900, color: '#475569' }}>{ausentes.length}</div><small style={{ color: '#475569', fontWeight: 700 }}>Ausentes</small></div>
            <div style={{ background: '#eff6ff', borderRadius: 10, padding: '8px 10px', textAlign: 'center' }}><div style={{ fontSize: '1.5rem', fontWeight: 900, color: '#1d4ed8' }}>{pct}%</div><small style={{ color: '#1d4ed8', fontWeight: 700 }}>Comparecimento</small></div>
          </div>
        )}
      </div>
      {minhaFalta && <CaixaJustificativa item={minhaFalta} onMudou={() => { onMudou && onMudou(); carregar(); }} />}
      {!lista ? <div style={{ textAlign: 'center', color: '#64748b', padding: 30 }}>Carregando…</div> : (
        <>
          <div style={{ fontWeight: 800, color: '#15803d' }}>Presentes ({presentes.length})</div>
          {presentes.length ? <div style={grade}>{presentes.map(v => <CartaoVereadorPresenca key={v.id} v={v} />)}</div> : <div style={{ color: '#64748b' }}>Ninguém registrou presença ainda.</div>}
          {ausentes.length > 0 && <>
            <div style={{ fontWeight: 800, color: '#64748b', marginTop: 4 }}>Ausentes ({ausentes.length}){ausentes.some(v => v.faltaJustificada) ? ` · ${ausentes.filter(v => v.faltaJustificada).length} com falta justificada` : ''}</div>
            <div style={grade}>{ausentes.map(v => <CartaoVereadorPresenca key={v.id} v={v} />)}</div>
          </>}
        </>
      )}
    </div>
  );
}

export function PresencaAoVivo({ sessaoId }) {
  const [sessoes, setSessoes] = useState(null);
  const [ano, setAno] = useState('');
  const [aberta, abrir] = useSubTela();
  const topo = useTopoAoAbrir(aberta);
  const carregar = useCallback(async () => {
    try {
      const r = await axios.get('/api/sessoes');
      const lista = (Array.isArray(r.data) ? r.data : []).filter(s => s.status !== 'AGENDADA')
        .sort((a, b) => (a.status === 'EM_ANDAMENTO' ? -1 : b.status === 'EM_ANDAMENTO' ? 1 : new Date(b.data) - new Date(a.data)));
      setSessoes(lista);
    } catch { setSessoes(s => s || []); }
  }, []);
  useEffect(() => { carregar(); }, [carregar, sessaoId]); // recarrega quando abre/encerra sessao
  // Faltas do proprio vereador (para justificar dentro da sessao). Admin/outros: sem lista.
  const [faltas, setFaltas] = useState({});
  const carregarFaltas = useCallback(async () => {
    try { const r = await axios.get('/api/justificativas/minhas'); const m = {}; (Array.isArray(r.data) ? r.data : []).forEach(x => { m[x.sessao.id] = x; }); setFaltas(m); }
    catch (e) { /* sem faltas para mostrar */ }
  }, []);
  useEffect(() => { carregarFaltas(); }, [carregarFaltas, sessaoId]);
  if (!sessoes) return <div style={{ textAlign: 'center', color: '#64748b', padding: 30 }}>Carregando…</div>;
  const atual = aberta && sessoes.find(s => s.id === aberta);
  if (atual) return <div ref={topo}><DetalhePresenca key={atual.id} sessao={atual} minhaFalta={faltas[atual.id]} onMudou={carregarFaltas} /></div>;
  if (!sessoes.length) return <div style={{ background: '#fff', borderRadius: 12, padding: 36, textAlign: 'center', border: '1px solid #e2e8f0', color: '#64748b' }}>Nenhuma sessão realizada ainda.</div>;
  const anos = [...new Set(sessoes.map(s => new Date(s.data).getUTCFullYear()))].sort((a, b) => b - a);
  const filtradas = ano ? sessoes.filter(s => new Date(s.data).getUTCFullYear() === Number(ano)) : sessoes;
  return (
    <div ref={topo}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <div style={{ flex: 1 }}>
          <b style={{ fontSize: '1.15rem', color: '#0f172a' }}>Escolha a sessão</b>
          <div style={{ color: '#64748b', fontSize: '.88rem' }}>{filtradas.length} sessão(ões) · toque para ver quem esteve presente</div>
        </div>
        {anos.length > 1 && (
          <select value={ano} onChange={e => setAno(e.target.value)} style={{ border: '1px solid #cbd5e1', borderRadius: 10, padding: '8px 10px', fontFamily: 'inherit', background: '#fff', color: '#0f172a', fontWeight: 700 }}>
            <option value="">Todos os anos</option>
            {anos.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        )}
      </div>
      <div className="pvc-lista-sessoes">
        {filtradas.map(s => (
          <LinhaSessao key={s.id} s={s} onClick={() => abrir(s.id)}
            info={s.status === 'EM_ANDAMENTO'
              ? <span className="pvc-chip" style={{ background: '#fee2e2', color: '#b91c1c' }}>● AO VIVO</span>
              : <>{dataHoraUTC(s.data).split(' às ')[0]} · {(s.pautas || []).length} matéria(s)</>}
            direita={faltas[s.id] ? (() => { const st = ST_JUST[faltas[s.id].justificativa ? faltas[s.id].justificativa.status : 'SEM']; return <span className="pvc-chip" style={{ background: st[2], color: st[1], flexShrink: 0 }}>{faltas[s.id].justificativa ? st[0] : 'Sua falta'}</span>; })() : null} />
        ))}
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
// Sessoes Anteriores: lista de sessoes; ao tocar, abre a tela DAQUELA sessao
// (materias, resultado, meu voto, documentos e como cada um votou).
const TIPO_P = { PROJETO_LEI: 'Projeto de Lei', PROJETO_RESOLUCAO: 'Proj. Resolução', PROJETO_DECRETO: 'Proj. Decreto', REQUERIMENTO: 'Requerimento', MOCAO: 'Moção', INDICACAO: 'Indicação', OUTROS: 'Outros', ATA_ANTERIOR: 'Ata da Sessão Anterior' };
const SIT = { ENCERRADA: ['Encerrada', '#475569', '#f1f5f9'], EM_ANDAMENTO: ['Em andamento', '#15803d', '#dcfce7'] };
const sitDe = (s) => SIT[s.status] || ['Agendada', '#1d4ed8', '#eff6ff'];

function MateriaSessao({ p, usuario, encerrada }) {
  const [docs, setDocs] = useState(false);
  const mv = (p.votos || []).find(v => v.vereadorId === usuario?.id);
  const sim = (p.votos || []).filter(v => v.opcao === 'SIM').length;
  const nao = (p.votos || []).filter(v => v.opcao === 'NAO').length;
  const abs = (p.votos || []).filter(v => v.opcao === 'ABSTENCAO').length;
  const res = p.status === 'APROVADA' ? ['Aprovada', '#15803d', '#dcfce7', '#16a34a'] : p.status === 'REPROVADA' ? ['Reprovada', '#b91c1c', '#fee2e2', '#dc2626'] : p.status === 'RETIRADA' ? ['Retirada', '#64748b', '#f1f5f9', '#94a3b8'] : ['Aguardando votação', '#1d4ed8', '#eff6ff', '#3b82f6'];
  const voto = mv?.opcao === 'SIM' ? ['Sim', '#15803d', '#dcfce7'] : mv?.opcao === 'NAO' ? ['Não', '#b91c1c', '#fee2e2'] : mv?.opcao === 'ABSTENCAO' ? ['Abstenção', '#92400e', '#fef9c3'] : [encerrada ? 'Não registrado' : '—', '#94a3b8', '#f1f5f9'];
  return (
    <div className="pvc-materia" style={{ borderLeftColor: res[3] }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ color: '#64748b', fontWeight: 700, fontSize: '.84rem' }}>{p.numero} · {TIPO_P[p.tipo] || p.tipo}</div>
        <div style={{ fontWeight: 800, fontSize: '1.12rem', color: '#0f172a', lineHeight: 1.35, margin: '3px 0 8px' }}>{p.titulo}</div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <span className="pvc-chip" style={{ background: res[2], color: res[1] }}>{res[0]}</span>
          {p.votacaoSecreta && <span className="pvc-chip" style={{ background: '#ede9fe', color: '#7c3aed' }}>Votação secreta</span>}
          {(sim + nao + abs) > 0 && <span style={{ color: '#64748b', fontSize: '.88rem', fontWeight: 700 }}><span style={{ color: '#15803d' }}>SIM {sim}</span> · <span style={{ color: '#b91c1c' }}>NÃO {nao}</span> · <span style={{ color: '#92400e' }}>ABST {abs}</span></span>}
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
          {p.projeto?.id && (
            <button type="button" onClick={() => setDocs(d => !d)} style={{ background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1d4ed8', borderRadius: 8, padding: '6px 12px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <FileText size={14} /> {docs ? 'Ocultar documentos' : 'Ver documentos'}
            </button>
          )}
        </div>
        {docs && p.projeto?.id && <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 8 }}><DocumentosDaMateria projetoId={p.projeto.id} /></div>}
        <VotosNominais votos={p.votos || []} secreta={p.votacaoSecreta} />
      </div>
      <div style={{ flexShrink: 0, textAlign: 'center' }}>
        <div style={{ color: '#94a3b8', fontSize: '.78rem', fontWeight: 700, marginBottom: 4 }}>Meu voto</div>
        <span style={{ display: 'inline-block', background: voto[2], color: voto[1], fontWeight: 800, padding: '6px 14px', borderRadius: 10 }}>{voto[0]}</span>
      </div>
    </div>
  );
}

// >>> PLENARIUM:SESSAO_ELEICAO -- em "Sessoes", a Eleicao da Mesa Diretora
// feita naquela sessao (chapa eleita, cargos, placar e o voto do vereador).
const ST_ELEICAO = { CONCLUIDA: ['Concluída', '#15803d', '#dcfce7'], EMPATE: ['Empate', '#b45309', '#fef3c7'], EM_VOTACAO: ['Em votação', '#1d4ed8', '#dbeafe'] };
function EleicaoNaSessao({ sessaoId, aoCarregar }) {
  const [lista, setLista] = useState(null);
  useEffect(() => {
    let vivo = true;
    if (!sessaoId) return undefined;
    axios.get(`/api/eleicoes/sessao/${sessaoId}`)
      .then(r => { if (!vivo) return; const l = (Array.isArray(r.data) ? r.data : []).filter(e => ST_ELEICAO[e.status]); setLista(l); if (aoCarregar) aoCarregar(l.length); })
      .catch(() => { if (vivo) { setLista([]); if (aoCarregar) aoCarregar(0); } });
    return () => { vivo = false; };
  }, [sessaoId, aoCarregar]);
  if (!lista || !lista.length) return null;
  return (
    <>
      {lista.map(el => {
        const st = ST_ELEICAO[el.status];
        const eleita = (el.chapas || []).find(c => c.id === el.chapaEleitaId);
        const chapas = [...(el.chapas || [])].sort((a, b) => (b.votos || 0) - (a.votos || 0));
        const total = chapas.reduce((a, c) => a + (c.votos || 0), 0) + (el.abstencoes || 0);
        const mv = el.meuVoto;
        const meuTxt = !mv ? null : !mv.jaVotou ? 'Você não votou' : el.votoSecreto ? 'Você votou (voto secreto)' : mv.abstencao ? 'Você se absteve' : (() => { const c = (el.chapas || []).find(x => x.id === mv.chapaId); return c ? `Você votou na Chapa ${c.numero}${c.nome ? ` · ${c.nome}` : ''}` : 'Você votou'; })();
        return (
          <div key={el.id} style={{ background: '#fff', borderRadius: 18, border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 4px 16px rgba(15,23,42,.05)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px', background: 'linear-gradient(135deg, #1e3a8a, #4338ca)', color: '#fff' }}>
              <span style={{ width: 44, height: 44, borderRadius: 12, background: 'rgba(255,255,255,.16)', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4z" /><path d="M17 5h3v2a3 3 0 0 1-3 3M7 5H4v2a3 3 0 0 0 3 3" /></svg>
              </span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '.72rem', fontWeight: 800, letterSpacing: 1.4, opacity: .8 }}>ELEIÇÃO DA MESA DIRETORA</div>
                <div style={{ fontSize: '1.15rem', fontWeight: 900 }}>Biênio {el.bienio}</div>
              </div>
              <span className="pvc-chip" style={{ background: st[2], color: st[1] }}>{st[0]}</span>
            </div>
            <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
              {eleita && (
                <div style={{ border: '2px solid #16a34a', background: '#f0fdf4', borderRadius: 14, padding: 12 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <span style={{ background: '#16a34a', color: '#fff', fontWeight: 900, fontSize: '.75rem', letterSpacing: 1, padding: '4px 10px', borderRadius: 999 }}>CHAPA ELEITA</span>
                    <b style={{ fontSize: '1.05rem', color: '#0f172a' }}>Chapa {eleita.numero}{eleita.nome ? ` · ${eleita.nome}` : ''}</b>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))', gap: 8, marginTop: 10 }}>
                    {(eleita.membros || []).map(m => (
                      <div key={m.cargo} style={{ background: '#fff', border: '1px solid #bbf7d0', borderRadius: 10, padding: '8px 10px' }}>
                        <div style={{ fontSize: '.72rem', fontWeight: 800, color: '#15803d', textTransform: 'uppercase', letterSpacing: .5 }}>{m.cargo}</div>
                        <div style={{ fontWeight: 800, color: '#0f172a' }}>{m.nome}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!el.totaisOcultos && chapas.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {chapas.map(c => {
                    const pct = total ? Math.round(((c.votos || 0) / total) * 100) : 0;
                    const ganhou = c.id === el.chapaEleitaId;
                    return (
                      <div key={c.id}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '.88rem', fontWeight: 700, color: '#334155' }}><span>Chapa {c.numero}{c.nome ? ` · ${c.nome}` : ''}</span><span>{c.votos || 0} voto(s)</span></div>
                        <div style={{ height: 8, borderRadius: 99, background: '#f1f5f9', overflow: 'hidden', marginTop: 4 }}><div style={{ width: `${pct}%`, height: '100%', background: ganhou ? '#16a34a' : '#94a3b8' }} /></div>
                      </div>
                    );
                  })}
                  {(el.abstencoes || 0) > 0 && <div style={{ fontSize: '.85rem', color: '#64748b', fontWeight: 600 }}>Abstenções: {el.abstencoes}</div>}
                </div>
              )}
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', fontSize: '.82rem', color: '#64748b', fontWeight: 600 }}>
                <span>{el.votoSecreto ? 'Voto secreto' : 'Voto aberto'}</span><span>·</span><span>{el.votaram} de {el.totalVereadores} votaram</span>
                {meuTxt && <><span>·</span><span style={{ color: '#1d4ed8' }}>{meuTxt}</span></>}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
// <<< PLENARIUM:SESSAO_ELEICAO

export function SessoesAnteriores({ historico = [], loadingHistorico, usuario }) {
  const [filtro, setFiltro] = useState('TODAS');
  const [aberta, abrir] = useSubTela();
  const topo = useTopoAoAbrir(aberta);
  const meus = (s) => (s.pautas || []).filter(p => (p.votos || []).some(v => v.vereadorId === usuario?.id)).length;
  const sessao = aberta && (historico || []).find(s => s.id === aberta);
  const [temEleicao, setTemEleicao] = useState(0); // PLENARIUM:SESSAO_ELEICAO
  if (sessao) {
    const st = sitDe(sessao); const pautas = sessao.pautas || [];
    return (
      <div ref={topo} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div className="pvc-cab-sessao">
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 900, fontSize: '1.15rem', color: '#0f172a', lineHeight: 1.3 }}>{sessao.titulo}</div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginTop: 4 }}>
                <span className="pvc-chip" style={{ background: st[2], color: st[1] }}>{st[0]}</span>
                <span style={{ color: '#64748b', fontSize: '.9rem' }}>{dataHoraUTC(sessao.data)}</span>
              </div>
            </div>
          </div>
          <div className="pvc-numeros">
            <div style={{ background: '#eff6ff', color: '#1d4ed8' }}><b>{pautas.length}</b><small>Matérias</small></div>
            <div style={{ background: '#dcfce7', color: '#15803d' }}><b>{pautas.filter(p => p.status === 'APROVADA').length}</b><small>Aprovadas</small></div>
            <div style={{ background: '#fee2e2', color: '#b91c1c' }}><b>{pautas.filter(p => p.status === 'REPROVADA').length}</b><small>Reprovadas</small></div>
            <div style={{ background: '#f1f5f9', color: '#334155' }}><b>{meus(sessao)}</b><small>Meus votos</small></div>
          </div>
        </div>
        <EleicaoNaSessao sessaoId={sessao.id} aoCarregar={setTemEleicao} /> {/* PLENARIUM:SESSAO_ELEICAO */}
        {!pautas.length
          ? (temEleicao ? null : <div style={{ background: '#fff', borderRadius: 16, padding: 30, textAlign: 'center', color: '#64748b' }}>Nenhuma matéria cadastrada nesta sessão.</div>)
          : pautas.map(p => <MateriaSessao key={p.id} p={p} usuario={usuario} encerrada={sessao.status === 'ENCERRADA'} />)}
      </div>
    );
  }
  const lista = (historico || []).filter(s => filtro === 'TODAS' ? true : filtro === 'AGENDADA' ? (s.status !== 'ENCERRADA' && s.status !== 'EM_ANDAMENTO') : s.status === filtro);
  const totalPautas = (historico || []).reduce((a, s) => a + ((s.pautas && s.pautas.length) || 0), 0);
  const totalMeus = (historico || []).reduce((a, s) => a + meus(s), 0);
  return (
    <div ref={topo}>
      <b style={{ fontSize: '1.15rem', color: '#0f172a' }}>Escolha a sessão</b>
      <div style={{ color: '#64748b', fontSize: '.88rem' }}>{(historico || []).length} sessão(ões) · {totalPautas} matéria(s) · {totalMeus} voto(s) seu(s)</div>
      <div className="pvc-filtros">
        {[['TODAS', 'Todas'], ['AGENDADA', 'Agendadas'], ['EM_ANDAMENTO', 'Em andamento'], ['ENCERRADA', 'Encerradas']].map(([id, rot]) => (
          <button key={id} type="button" className={`pvc-filtro ${filtro === id ? 'ativo' : ''}`} onClick={() => setFiltro(id)}>{rot}</button>
        ))}
      </div>
      {loadingHistorico ? <div style={{ textAlign: 'center', color: '#64748b', padding: 30 }}>Carregando…</div>
        : !lista.length ? <div style={{ background: '#fff', borderRadius: 16, padding: 36, textAlign: 'center', color: '#64748b' }}>Nenhuma sessão nesta situação.</div>
        : (
          <div className="pvc-lista-sessoes">
            {lista.map(s => {
              const st = sitDe(s); const n = meus(s);
              return (
                <LinhaSessao key={s.id} s={s} onClick={() => abrir(s.id)}
                  info={<><span className="pvc-chip" style={{ background: st[2], color: st[1] }}>{st[0]}</span><span>{dataHoraUTC(s.data)}</span><span>· {(s.pautas || []).length} matéria(s)</span></>}
                  direita={n > 0 ? <span className="pvc-chip" style={{ background: '#dcfce7', color: '#15803d', flexShrink: 0 }}>{n} voto(s)</span> : null} />
              );
            })}
          </div>
        )}
    </div>
  );
}

// ---------------------------------------------------------------------
// Sessoes Anteriores: como cada vereador votou (com foto). So votacao
// aberta; a secreta continua mostrando so os totais.
export function VotosNominais({ votos = [], secreta }) {
  const fotos = useFotos();
  const [aberto, setAberto] = useState(false);
  if (secreta || !votos.length) return null;
  const grupos = [['SIM', 'Votaram SIM', '#15803d', '#dcfce7'], ['NAO', 'Votaram NÃO', '#b91c1c', '#fee2e2'], ['ABSTENCAO', 'Abstenções', '#92400e', '#fef9c3']];
  return (
    <div style={{ marginTop: 8 }}>
      <button type="button" onClick={(e) => { e.stopPropagation(); setAberto(a => !a); }} style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '6px 12px', fontWeight: 700, color: '#334155', cursor: 'pointer', fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        <Users size={14} /> {aberto ? 'Ocultar votos nominais' : `Ver como cada um votou (${votos.length})`}
      </button>
      {aberto && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 10 }}>
          {grupos.map(([op, rot, cor, bg]) => {
            const lista = votos.filter(v => v.opcao === op);
            if (!lista.length) return null;
            return (
              <div key={op}>
                <div style={{ fontWeight: 800, color: cor, fontSize: '.85rem', marginBottom: 6 }}>{rot} ({lista.length})</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {lista.map(v => (
                    <span key={v.id || v.vereadorId} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: bg, borderRadius: 10, padding: '4px 10px 4px 4px' }}>
                      <Foto url={fotos[v.vereadorId]} nome={nomeV(v.vereador)} w={34} h={42} raio={6} />
                      <b style={{ fontSize: '.88rem', color: '#0f172a' }}>{nomeV(v.vereador) || 'Vereador'}</b>
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ---------------------------------------------------------------------
// Quando uma pauta sai de EM_VOTACAO para APROVADA/REPROVADA, mostra o
// resultado por alguns segundos. O vereador continua na tela da Votacao.
export function AvisoResultado({ pautas = [] }) {
  const antesRef = useRef(null);
  const [aviso, setAviso] = useState(null);
  useEffect(() => {
    const atual = {};
    pautas.forEach(p => { atual[p.id] = p.status; });
    const antes = antesRef.current;
    antesRef.current = atual;
    if (!antes) return;
    const encerrada = pautas.find(p => antes[p.id] === 'EM_VOTACAO' && (p.status === 'APROVADA' || p.status === 'REPROVADA'));
    if (encerrada) {
      const v = encerrada.votos || [];
      setAviso({ numero: encerrada.numero, titulo: encerrada.titulo, status: encerrada.status, sim: v.filter(x => x.opcao === 'SIM').length, nao: v.filter(x => x.opcao === 'NAO').length, abs: v.filter(x => x.opcao === 'ABSTENCAO').length });
    }
  }, [pautas]);
  useEffect(() => {
    if (!aviso) return undefined;
    const t = setTimeout(() => setAviso(null), 7000);
    return () => clearTimeout(t);
  }, [aviso]);
  if (!aviso) return null;
  const ok = aviso.status === 'APROVADA';
  return (
    <div onClick={() => setAviso(null)} style={{ position: 'fixed', inset: 0, zIndex: 2147481000, background: 'rgba(15,23,42,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 20, width: 'min(520px, 100%)', padding: '26px 22px', textAlign: 'center', border: `4px solid ${ok ? '#16a34a' : '#dc2626'}` }}>
        <div style={{ color: '#64748b', fontWeight: 800, letterSpacing: 1, fontSize: '.85rem' }}>VOTAÇÃO ENCERRADA</div>
        <div style={{ fontSize: '1.15rem', fontWeight: 800, color: '#0f172a', marginTop: 6 }}>{aviso.numero}</div>
        <div style={{ color: '#475569', fontSize: '.92rem', marginTop: 2 }}>{aviso.titulo}</div>
        <div style={{ fontSize: '2rem', fontWeight: 900, color: ok ? '#15803d' : '#b91c1c', margin: '12px 0' }}>{ok ? '✅ APROVADA' : '❌ REPROVADA'}</div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 18, fontWeight: 800, fontSize: '1.05rem' }}>
          <span style={{ color: '#15803d' }}>SIM {aviso.sim}</span><span style={{ color: '#b91c1c' }}>NÃO {aviso.nao}</span><span style={{ color: '#92400e' }}>ABST. {aviso.abs}</span>
        </div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
// Botao "voltar" do proprio aparelho (Android: seta de voltar; iPhone/iPad:
// arrastar da borda). Cada tela dos cards vira um passo no historico:
//   voltar na Ordem do Dia  -> fecha a Ordem do Dia
//   voltar em qualquer tela -> Inicio (os cards)
//   voltar no Inicio        -> continua no Inicio (nao cai no login; sair
//                              continua sendo pelo menu "Sair")
// Mesmo endereco de pagina o tempo todo: nada muda nas rotas do sistema.

// Acesso do vereador desconectado (pelo admin ou por troca de senha) ou
// vencido: avisa e leva ao login, sem deixar o painel "quebrado".
function useAcessoDesconectado() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const feito = useRef(false);
  const atual = useRef({});
  atual.current = { usuario, logout, navigate };
  useEffect(() => {
    const id = axios.interceptors.response.use((r) => r, (err) => {
      const st = err && err.response && err.response.status;
      const url = (err && err.config && err.config.url) || '';
      if (st === 401 && !/\/api\/auth\//.test(url) && !feito.current) {
        feito.current = true;
        const desligado = err.response.data && err.response.data.codigo === 'ACESSO_DESCONECTADO';
        toast.error(desligado
          ? 'Seu acesso foi desconectado neste aparelho (senha alterada ou pelo administrador). Entre novamente.'
          : 'Seu acesso expirou. Entre novamente.', { duration: 8000 });
        const { usuario: u, logout: sairDoSistema, navigate: ir } = atual.current;
        const slug = u && u.camara && u.camara.slug;
        try { sairDoSistema(); } catch (e) { /* segue */ }
        ir(slug ? `/camara/${slug}/login/vereador` : '/login/vereador', { replace: true });
      }
      return Promise.reject(err);
    });
    return () => axios.interceptors.response.eject(id);
  }, []);
}

export function VoltarDoCelular({ aba, setAba, verOrdem, setVerOrdem }) {
  useAcessoDesconectado(); // PLENARIUM:ACESSO
  useTemaPainel(); // PLENARIUM:TEMA
  const pulando = useRef(0);                 // "voltar" que nos mesmos disparamos
  const pendente = useRef(null);            // aba para marcar depois de um desses "voltar"
  const atual = useRef({ aba, ordem: false });
  const marca = (extra) => {
    const s = { ...(window.history.state || {}) }; delete s.pvc; delete s.pvcOrdem; delete s.pvcSub;
    return { ...s, ...extra };
  };
  useEffect(() => {
    try {
      window.history.replaceState(marca({ pvc: 'raiz' }), '');
      window.history.pushState(marca({ pvc: 'inicio' }), '');
      if (atual.current.aba !== 'inicio') window.history.pushState(marca({ pvc: atual.current.aba }), '');
    } catch (e) { return undefined; }
    const aoVoltar = (ev) => {
      if (pulando.current > 0) {
        pulando.current -= 1;
        if (pendente.current) { try { window.history.replaceState(marca({ pvc: pendente.current }), ''); } catch (e) { /* segue */ } pendente.current = null; }
        return;
      }
      const st = ev.state || {};
      if (!st.pvc || st.pvc === 'raiz') {            // tentou sair do painel: fica no Inicio
        try { window.history.pushState(marca({ pvc: 'inicio' }), ''); } catch (e) { /* segue */ }
        atual.current = { aba: 'inicio', ordem: false };
        setVerOrdem(false); setAba('inicio'); return;
      }
      atual.current = { aba: st.pvc, ordem: !!st.pvcOrdem };
      setVerOrdem(!!st.pvcOrdem); setAba(st.pvc);
    };
    window.addEventListener('popstate', aoVoltar);
    return () => window.removeEventListener('popstate', aoVoltar);
  }, []);

  useEffect(() => {                                   // mudou de tela pelos botoes
    const a = atual.current;
    if (aba === a.aba) return;
    try {
      if (aba === 'inicio') { const h = window.history.state || {}; pulando.current += 1; window.history.go(-(1 + (h.pvcOrdem ? 1 : 0) + (h.pvcSub ? 1 : 0))); }
      else if (a.aba === 'inicio') window.history.pushState(marca({ pvc: aba }), '');
      else { // aba -> aba (pelas abas): continua um passo so acima do Inicio
        const h = window.history.state || {}; const extra = (h.pvcOrdem ? 1 : 0) + (h.pvcSub ? 1 : 0);
        if (extra) { pulando.current += 1; pendente.current = aba; window.history.go(-extra); }
        else window.history.replaceState(marca({ pvc: aba }), '');
      }
    } catch (e) { /* segue */ }
    atual.current = { aba, ordem: false };
  }, [aba]);

  useEffect(() => {                                   // abriu/fechou a Ordem do Dia pelos botoes
    const a = atual.current;
    if (!!verOrdem === a.ordem) return;
    try {
      if (verOrdem) window.history.pushState(marca({ pvc: a.aba, pvcOrdem: true }), '');
      else { pulando.current += 1; window.history.back(); }
    } catch (e) { /* segue */ }
    atual.current = { ...a, ordem: !!verOrdem };
  }, [verOrdem]);

  return null;
}

// ---------------------------------------------------------------------
// Confirmacao do voto (no lugar da caixinha antiga). Mesmo fluxo: Cancelar
// ou Confirmar (que chama o mesmo confirmarVoto do painel).
const ROTULO_VOTO = { SIM: 'SIM', NAO: 'NÃO', ABSTENCAO: 'ABSTENÇÃO' };
export function ConfirmarVoto({ opcao, pauta, votando, onCancelar, onConfirmar }) {
  useEffect(() => {
    if (!opcao) return undefined;
    const tecla = (e) => { if (e.key === 'Escape' && !votando) onCancelar(); };
    window.addEventListener('keydown', tecla);
    return () => window.removeEventListener('keydown', tecla);
  }, [opcao, votando, onCancelar]);
  if (!opcao) return null;
  return (
    <div className={`pvc-cv-fundo pvc-cv-${opcao}`} onClick={() => { if (!votando) onCancelar(); }}>
      <div className="pvc-cv" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="pvc-cv-ic" />
        <div className="pvc-cv-tit">Confirmar seu voto</div>
        <div className="pvc-cv-voto">{ROTULO_VOTO[opcao] || opcao}</div>
        {pauta && (
          <div className="pvc-cv-materia">
            <small>{pauta.numero}</small>
            <b>{pauta.titulo}</b>
          </div>
        )}
        <div className="pvc-cv-aviso">Depois de confirmado, o voto não pode ser alterado.</div>
        <div className="pvc-cv-bts">
          <button type="button" className="pvc-cv-cancelar" onClick={onCancelar} disabled={votando}>Cancelar</button>
          <button type="button" className="pvc-cv-ok" onClick={onConfirmar} disabled={votando}>{votando ? 'Registrando…' : 'Confirmar voto'}</button>
        </div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------
// Justificar Falta (PLENARIUM:JUSTIFICATIVA): sessoes encerradas em que o
// vereador nao teve presenca; ele escreve o motivo e a Mesa/admin aceita
// ou recusa. O motivo so aparece para ele e para o admin.
const ST_JUST = {
  SEM: ['Sem justificativa', '#b91c1c', '#fee2e2'],
  PENDENTE: ['Em análise', '#b45309', '#fef3c7'],
  ACEITA: ['Falta justificada', '#15803d', '#dcfce7'],
  RECUSADA: ['Justificativa recusada', '#b91c1c', '#fee2e2']
};
export function JustificarFalta() {
  const [lista, setLista] = useState(null);
  const [aberta, abrir] = useSubTela();
  const [motivo, setMotivo] = useState('');
  const [enviando, setEnviando] = useState(false);
  const topo = useTopoAoAbrir(aberta);
  const carregar = useCallback(async () => {
    try { const r = await axios.get('/api/justificativas/minhas'); setLista(Array.isArray(r.data) ? r.data : []); }
    catch (e) { setLista(l => l || []); toast.error((e && e.response && e.response.data && e.response.data.error) || 'Não foi possível carregar suas faltas.'); }
  }, []);
  useEffect(() => { carregar(); }, [carregar]);
  const item = aberta && (lista || []).find(x => x.sessao.id === aberta);
  useEffect(() => { setMotivo(item && item.justificativa ? item.justificativa.motivo : ''); }, [aberta]); // recarrega o texto ao abrir outra falta
  if (!lista) return <div style={{ textAlign: 'center', color: '#64748b', padding: 30 }}>Carregando…</div>;
  const enviar = async () => {
    if (motivo.trim().length < 5) { toast.error('Escreva o motivo da falta.'); return; }
    setEnviando(true);
    try { await axios.post('/api/justificativas', { sessaoId: item.sessao.id, motivo: motivo.trim() }); toast.success('Justificativa enviada. Aguarde a análise da Mesa.'); await carregar(); window.history.back(); }
    catch (e) { toast.error((e && e.response && e.response.data && e.response.data.error) || 'Não foi possível enviar.'); }
    finally { setEnviando(false); }
  };
  const retirar = async () => {
    if (!window.confirm('Retirar esta justificativa?')) return;
    try { await axios.delete(`/api/justificativas/${item.justificativa.id}`); toast.success('Justificativa retirada.'); await carregar(); window.history.back(); }
    catch (e) { toast.error((e && e.response && e.response.data && e.response.data.error) || 'Não foi possível retirar.'); }
  };
  if (item) {
    const j = item.justificativa; const st = ST_JUST[j ? j.status : 'SEM'];
    const podeEditar = !j || j.status !== 'ACEITA';
    return (
      <div ref={topo} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div className="pvc-cab-sessao">
          <div style={{ fontWeight: 900, fontSize: '1.12rem', color: '#0f172a', lineHeight: 1.3 }}>{item.sessao.titulo}</div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <span className="pvc-chip" style={{ background: st[2], color: st[1] }}>{st[0]}</span>
            <span style={{ color: '#64748b', fontSize: '.9rem' }}>{dataHoraUTC(item.sessao.data)}</span>
          </div>
          {j && j.status !== 'PENDENTE' && j.decididoPor && (
            <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: '10px 12px', color: '#334155', fontSize: '.92rem' }}>
              <b>{j.status === 'ACEITA' ? 'Aceita' : 'Recusada'}</b> por {j.decididoPor}{j.decididoEm ? ` em ${new Date(j.decididoEm).toLocaleDateString('pt-BR')}` : ''}{j.decisaoObs ? <><br />Observação: {j.decisaoObs}</> : null}
            </div>
          )}
        </div>
        <div className="pvc-cab-sessao">
          <b style={{ color: '#0f172a' }}>Motivo da falta</b>
          <textarea value={motivo} onChange={e => setMotivo(e.target.value)} disabled={!podeEditar || enviando} maxLength={2000} rows={6}
            placeholder="Ex.: compromisso oficial representando a Câmara em Manaus; consulta médica; viagem a serviço…"
            style={{ width: '100%', border: '1px solid #cbd5e1', borderRadius: 12, padding: 12, fontSize: '1rem', fontFamily: 'inherit', resize: 'vertical', background: podeEditar ? '#fff' : '#f8fafc', color: '#0f172a', boxSizing: 'border-box' }} />
          <small style={{ color: '#64748b' }}>O motivo fica visível só para você e para a Mesa/administração. Nas listas de presença aparece apenas "falta justificada", depois de aceita.</small>
          {podeEditar && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {j && j.status === 'PENDENTE' && <button type="button" className="pvc-bt" onClick={retirar} disabled={enviando}>Retirar</button>}
              <button type="button" className="pvc-bt pvc-bt-azul" style={{ flex: 1, justifyContent: 'center', background: '#2563eb', color: '#fff', borderColor: '#2563eb' }} onClick={enviar} disabled={enviando}>
                {enviando ? 'Enviando…' : j ? (j.status === 'RECUSADA' ? 'Enviar novamente' : 'Salvar alteração') : 'Enviar justificativa'}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
  const pend = lista.filter(x => !x.justificativa).length;
  return (
    <div ref={topo}>
      <b style={{ fontSize: '1.15rem', color: '#0f172a' }}>Minhas faltas</b>
      <div style={{ color: '#64748b', fontSize: '.88rem', marginBottom: 12 }}>
        {lista.length ? `${lista.length} falta(s) em sessões encerradas${pend ? ` · ${pend} sem justificativa` : ''} · toque para justificar` : 'Sessões encerradas em que não houve sua presença aparecem aqui.'}
      </div>
      {!lista.length
        ? <div style={{ background: '#fff', borderRadius: 16, padding: 36, textAlign: 'center', color: '#15803d', fontWeight: 700 }}>Nenhuma falta registrada. 👏</div>
        : (
          <div className="pvc-lista-sessoes">
            {lista.map(x => {
              const st = ST_JUST[x.justificativa ? x.justificativa.status : 'SEM'];
              return <LinhaSessao key={x.sessao.id} s={{ ...x.sessao, status: 'ENCERRADA' }} onClick={() => abrir(x.sessao.id)}
                info={<><span className="pvc-chip" style={{ background: st[2], color: st[1] }}>{st[0]}</span><span>{dataHoraUTC(x.sessao.data)}</span></>} />;
            })}
          </div>
        )}
    </div>
  );
}

// Quadro "Voce faltou nesta sessao" dentro da presenca da sessao: o vereador
// escreve o motivo e envia; a Mesa/admin aceita ou recusa.
function CaixaJustificativa({ item, onMudou }) {
  const j = item.justificativa;
  const [motivo, setMotivo] = useState(j ? j.motivo : '');
  const [editando, setEditando] = useState(!j);
  const [enviando, setEnviando] = useState(false);
  useEffect(() => { setMotivo(j ? j.motivo : ''); setEditando(!j); }, [j]);
  const st = ST_JUST[j ? j.status : 'SEM'];
  const podeEditar = !j || j.status !== 'ACEITA';
  const enviar = async () => {
    if (motivo.trim().length < 5) { toast.error('Escreva o motivo da falta.'); return; }
    setEnviando(true);
    try { await axios.post('/api/justificativas', { sessaoId: item.sessao.id, motivo: motivo.trim() }); toast.success('Justificativa enviada. Aguarde a análise da Mesa.'); onMudou && onMudou(); }
    catch (e) { toast.error((e && e.response && e.response.data && e.response.data.error) || 'Não foi possível enviar.'); }
    finally { setEnviando(false); }
  };
  const retirar = async () => {
    if (!window.confirm('Retirar esta justificativa?')) return;
    try { await axios.delete(`/api/justificativas/${j.id}`); toast.success('Justificativa retirada.'); onMudou && onMudou(); }
    catch (e) { toast.error((e && e.response && e.response.data && e.response.data.error) || 'Não foi possível retirar.'); }
  };
  return (
    <div style={{ background: '#fff7ed', border: '2px solid #fdba74', borderRadius: 16, padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <Calendar size={20} color="#c2410c" />
        <b style={{ flex: 1, color: '#9a3412', fontSize: '1.02rem' }}>Você não teve presença nesta sessão</b>
        <span className="pvc-chip" style={{ background: st[2], color: st[1] }}>{st[0]}</span>
      </div>
      {j && j.status !== 'PENDENTE' && j.decididoPor && (
        <div style={{ color: '#334155', fontSize: '.9rem' }}>
          <b>{j.status === 'ACEITA' ? 'Aceita' : 'Recusada'}</b> por {j.decididoPor}{j.decididoEm ? ` em ${new Date(j.decididoEm).toLocaleDateString('pt-BR')}` : ''}{j.decisaoObs ? ` · Observação: ${j.decisaoObs}` : ''}
        </div>
      )}
      {j && !editando ? (
        <>
          <div style={{ background: '#fff', border: '1px solid #fed7aa', borderRadius: 12, padding: '10px 12px', color: '#0f172a', whiteSpace: 'pre-wrap' }}><b>Motivo:</b> {j.motivo}</div>
          {podeEditar && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {j.status === 'PENDENTE' && <button type="button" className="pvc-bt" onClick={retirar}>Retirar</button>}
              <button type="button" className="pvc-bt" onClick={() => setEditando(true)}>{j.status === 'RECUSADA' ? 'Enviar outra justificativa' : 'Editar motivo'}</button>
            </div>
          )}
        </>
      ) : (
        <>
          <textarea value={motivo} onChange={e => setMotivo(e.target.value)} disabled={enviando} maxLength={2000} rows={4}
            placeholder="Escreva o motivo da falta. Ex.: compromisso oficial representando a Câmara; consulta médica; viagem a serviço…"
            style={{ width: '100%', border: '1px solid #fdba74', borderRadius: 12, padding: 12, fontSize: '1rem', fontFamily: 'inherit', resize: 'vertical', background: '#fff', color: '#0f172a', boxSizing: 'border-box' }} />
          <small style={{ color: '#9a3412' }}>O motivo fica visível só para você e para a Mesa/administração. Na lista de presença aparece apenas "falta justificada", depois de aceita.</small>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {j && <button type="button" className="pvc-bt" onClick={() => { setMotivo(j.motivo); setEditando(false); }} disabled={enviando}>Cancelar</button>}
            <button type="button" className="pvc-bt" style={{ flex: 1, justifyContent: 'center', background: '#c2410c', color: '#fff', borderColor: '#c2410c' }} onClick={enviar} disabled={enviando}>
              {enviando ? 'Enviando…' : 'Enviar justificativa'}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
